// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3KXs3":[function(require,module,exports) {
var _productVariantPicker = require("./sections/product-variant-picker");
var _productDetailsTabs = require("./sections/product-details-tabs");
var _socialCarousel = require("./sections/social-carousel");
var _cardCarousel = require("./sections/card-carousel");
var _expandingCards = require("./sections/expanding-cards");
var _expandingCardsHover = require("./sections/expanding-cards-hover");
var _scrollAnimatedCards = require("./sections/scroll-animated-cards");
var _stickyCards = require("./sections/sticky-cards");
var _imageHero = require("./sections/image-hero");
var _infoCardGrid = require("./sections/info-card-grid");
var _productPaymentTabs = require("./snippets/product-payment-tabs");
var _gorgias = require("./apps/gorgias");
initModules([
    (0, _productVariantPicker.productVariantPicker),
    (0, _productDetailsTabs.productDetailsTabs),
    (0, _socialCarousel.socialCarousel),
    (0, _cardCarousel.cardCarousel),
    (0, _expandingCards.expandingCards),
    (0, _expandingCardsHover.expandingCardsHover),
    (0, _scrollAnimatedCards.scrollAnimatedCards),
    (0, _infoCardGrid.infoCardGrid),
    (0, _stickyCards.stickyCards),
    (0, _imageHero.imageHero),
    (0, _productPaymentTabs.productPaymentTabs),
    (0, _gorgias.gorgias)
]);
function initModules(modules) {
    modules.forEach((module)=>{
        module.init();
    });
}

},{"./sections/product-variant-picker":"04DHM","./sections/product-details-tabs":"63obo","./sections/social-carousel":"5Cdzw","./sections/card-carousel":"lTyqw","./sections/expanding-cards":"fe4OJ","./sections/expanding-cards-hover":"hZcLp","./sections/scroll-animated-cards":"XJY2c","./sections/sticky-cards":"3uhO8","./sections/image-hero":"gyUlW","./sections/info-card-grid":"dsJyx","./snippets/product-payment-tabs":"kqvQC","./apps/gorgias":"eSyom"}],"04DHM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "productVariantPicker", ()=>productVariantPicker);
var _moduleClass = require("../globals/module-class");
var _breadPay = require("../apps/bread-pay");
class ProductFormManager extends (0, _moduleClass.FLModule) {
    constructor(productInfoElement){
        super("productFormManager");
        this.variantSelects = null;
        this.labelSwatches = document.querySelectorAll(".never-match");
        this.variants = [];
        this.productInfo = productInfoElement;
        this.variants = [];
        this.init();
        this.refreshElementReferences();
    }
    init() {
        this.loadVariantsData();
        const currentVariantScript = this.productInfo.querySelector("script[data-selected-variant]");
        if (currentVariantScript) try {
            const currentVariantData = JSON.parse(currentVariantScript.textContent || "{}");
            this.log("Initial variant data:", currentVariantData);
            this.updateOptionPrices(currentVariantData);
            if (currentVariantData?.price) (0, _breadPay.breadPay).updatePrices(this.productInfo, currentVariantData.price);
        } catch (e) {
            console.error("Error parsing initial variant data:", e);
        }
        const form = this.productInfo.querySelector("form[is='product-form']");
        if (!form) {
            this.log("No product form found in product-info");
            return;
        }
        form.addEventListener("variant:change", (evt)=>{
            this.refreshElementReferences();
            this.updateOptionPrices(evt.detail.variant);
            if (evt.detail.variant?.price !== undefined) (0, _breadPay.breadPay).updatePrices(this.productInfo, evt.detail.variant.price);
        });
    }
    refreshElementReferences() {
        this.variantSelects = this.productInfo.querySelector("variant-selects");
        this.labelSwatches = this.productInfo.querySelectorAll(".label-swatch") ?? document.querySelectorAll(".never-match");
    }
    loadVariantsData() {
        if (!this.variantSelects) {
            this.log("No variant-selects element found");
            return;
        }
        const variantDataScript = this.variantSelects.querySelector("[data-variants]");
        if (variantDataScript) {
            const productData = JSON.parse(variantDataScript.textContent || "{}");
            this.variants = productData || [];
            this.log("Loaded variants data", this.variants);
        }
    }
    updateOptionPrices(variant) {
        const basePrice = variant.price;
        this.log("variants", this.variants);
        this.log("labelSwatches", this.labelSwatches);
        this.labelSwatches?.forEach((swatch)=>{
            const optionValue = swatch.previousElementSibling?.getAttribute("data-option-value");
            this.log("optionValue", optionValue);
            if (!optionValue) return;
            const variantWithOption = this.variants.find((v)=>v.options.includes(optionValue));
            this.log("variantWithOption", variantWithOption);
            if (variantWithOption) {
                const priceDifference = variantWithOption.price - basePrice;
                const priceSpan = swatch.querySelector(".option-value__price");
                this.log("priceSpan", priceSpan);
                this.log("priceDifference", priceDifference);
                if (priceSpan && priceDifference !== 0) priceSpan.textContent = priceDifference > 0 ? `${this.formatMoney(priceDifference)}` : this.formatMoney(priceDifference);
            }
        });
    }
    formatMoney(cents) {
        // @ts-expect-error theme is not defined in the global scope
        const currency = window.theme?.settings?.moneyWithCurrencyFormat ? window.theme.settings.moneyWithCurrencyFormat.split(" ")[1] : "USD";
        const modifier = cents < 0 ? "-" : "+";
        cents = cents < 0 ? cents * -1 : cents;
        // add commas to the price in the correct place
        const price = Intl.NumberFormat("en-US", {
            style: "currency",
            currency
        }).format(cents / 100);
        return modifier + price.replace(".00", "");
    }
}
class ProductVariantPickerModule extends (0, _moduleClass.FLModule) {
    constructor(){
        super("productVariantPicker");
        this.formManagers = new Map();
    }
    init() {
        document.addEventListener("DOMContentLoaded", ()=>{
            const productInfoElements = document.querySelectorAll("product-info");
            this.log("productVariantPicker init");
            productInfoElements.forEach((productInfo)=>{
                const formManager = new ProductFormManager(productInfo);
                this.formManagers.set(productInfo, formManager);
            });
        });
    }
}
const productVariantPicker = new ProductVariantPickerModule();

},{"../globals/module-class":"2nrKQ","../apps/bread-pay":"3e5TK","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"2nrKQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FLModule", ()=>FLModule);
var _logger = require("./logger");
class FLModule {
    constructor(moduleName){
        this.moduleName = moduleName;
        const logger = (0, _logger.createLogger)(moduleName);
        this.log = logger.log;
        this.trace = logger.trace;
    }
}

},{"./logger":"k7M8y","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"k7M8y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLogger", ()=>createLogger);
const createLogger = (moduleName, debugModeCheck = ()=>window.location.href.includes("127.0.0.1"))=>{
    const formatModulePrefix = ()=>moduleName ? `[${moduleName}]` : "";
    const isDebugMode = ()=>debugModeCheck();
    return {
        log: (...args)=>{
            if (isDebugMode()) console.log(formatModulePrefix(), ...args);
        },
        trace: (...args)=>{
            if (isDebugMode()) console.trace(formatModulePrefix(), ...args);
        }
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"5fhYl":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"3e5TK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BreadPay", ()=>BreadPay);
parcelHelpers.export(exports, "breadPay", ()=>breadPay);
var _moduleClass = require("../globals/module-class");
const options = {
    method: "GET",
    headers: {
        accept: "application/json"
    }
};
const apiDomain = "https://api.pp-prod-ads.ue2.breadgateway.net/";
const merchantId = "f642390a-1a06-4be0-8d0b-a788e169dc58";
const programId = "2a1d717a-e4ea-43fc-9d2b-6844f06eda79";
class BreadPay extends (0, _moduleClass.FLModule) {
    constructor(){
        super("BreadPay");
        this.log("BreadPay constructor");
    }
    init() {}
    updatePrices(container, priceInCents) {
        this.log("BreadPay: updatePrices", container);
        const customContainer = container.querySelector(".custom-bread-pay-container");
        const customPriceContainer = customContainer?.querySelector(".custom-bread-pay-price");
        const defaultContainer = container.querySelector(".bread-pay-container");
        if (!customContainer || !customPriceContainer) {
            // If the custom container doesn't exist, there's nothing to update.
            // We might want to ensure the default one is visible, but the logic below handles showing it on failure.
            // console.error("BreadPay: .custom-bread-pay-container not found within", container);
            this.log("BreadPay: .custom-bread-pay-container not found within", container);
            return;
        }
        // Helper function to manage visibility
        const setVisibility = (showCustom)=>{
            if (customContainer) customContainer.hidden = !showCustom;
            if (defaultContainer) defaultContainer.hidden = showCustom;
            else if (!showCustom) // If the default container doesn't exist, and we want to hide the custom one,
            // log a warning as there's no fallback.
            this.log("Warning: Hiding custom BreadPay container, but no default .bread-pay-container found as fallback.", container);
        };
        const discount = customContainer.dataset.discount || "0";
        const price = priceInCents !== undefined ? priceInCents : parseInt(customContainer.dataset.price || "0");
        const amount = this.calculatePriceWithDiscount(price, discount);
        this.log("BreadPay: updatePrices", {
            amount,
            price,
            discount
        });
        if (amount === undefined || amount === null) {
            console.error("BreadPay: Price/amount is missing or invalid.", {
                container,
                element: customContainer,
                providedPrice: priceInCents,
                dataPrice: customContainer.dataset.price
            });
            setVisibility(false); // Show default container on price error
            return;
        }
        const apiUrl = `${apiDomain}api/experience/servicing/as-low-as?merchantId=${merchantId}&amount=${amount}&programId=${programId}`;
        fetch(apiUrl, options).then(async (res)=>{
            if (!res.ok) throw new Error(`HTTP error accessing BreadPay API. Status: ${res.status}, ${await res.text()}`);
            return res.json();
        }).then((data)=>{
            if (data?.asLowAs?.paymentAmountText?.["en-us"]) {
                const priceText = data.asLowAs.paymentAmountText["en-us"];
                const newText = `As low as ${priceText}/mo`;
                if (customPriceContainer.textContent !== newText) {
                    customPriceContainer.textContent = newText;
                    this.log(`Updated custom BreadPay text to: ${newText}`, customPriceContainer);
                }
                setVisibility(true); // Show custom, hide default
            } else {
                console.error("BreadPay: Invalid API response structure or missing 'en-us' text", data);
                setVisibility(false); // Show default on invalid data
            }
        }).catch((err)=>{
            console.error("BreadPay API Fetch Error:", err);
            setVisibility(false); // Show default on fetch error
        });
    }
    calculatePriceWithDiscount(price, discount) {
        if (discount.includes("%")) {
            const discountAmount = parseFloat(discount);
            if (!isNaN(discountAmount)) return price - price * discountAmount / 100;
        } else {
            const discountAmount = parseInt(discount);
            if (!isNaN(discountAmount)) return price - discountAmount * 100; // Convert discount to cents
        }
        return price;
    }
}
const breadPay = new BreadPay();

},{"../globals/module-class":"2nrKQ","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"63obo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProductDetailsTabs", ()=>ProductDetailsTabs);
parcelHelpers.export(exports, "productDetailsTabs", ()=>productDetailsTabs);
var _moduleClass = require("../globals/module-class");
class ProductDetailsTabs extends (0, _moduleClass.FLModule) {
    constructor(){
        super("ProductDetailsTabs");
    }
    init() {
        if (!customElements.get("product-details-tabs")) customElements.define("product-details-tabs", ProductDetailsTabsElement);
    }
}
const productDetailsTabs = new ProductDetailsTabs();
class ProductDetailsTabsElement extends HTMLElement {
    constructor(){
        super();
        this.tabButtons = this.querySelectorAll(".product-details-tabs__tab-button");
        this.tabPanels = this.querySelectorAll(".product-details-tabs__panel");
    }
    connectedCallback() {
        this.bindEvents();
    }
    bindEvents() {
        this.tabButtons.forEach((button)=>{
            button.addEventListener("click", ()=>this.handleTabClick(button));
        });
        // Handle keyboard navigation
        this.tabButtons.forEach((button)=>{
            button.addEventListener("keydown", (event)=>this.handleKeydown(event));
        });
    }
    handleTabClick(clickedButton) {
        // Deactivate all tabs
        this.tabButtons.forEach((button)=>{
            button.classList.remove("is-active");
            button.setAttribute("aria-selected", "false");
        });
        this.tabPanels.forEach((panel)=>{
            panel.classList.remove("is-active");
            panel.setAttribute("hidden", "");
        });
        // Activate clicked tab
        clickedButton.classList.add("is-active");
        clickedButton.setAttribute("aria-selected", "true");
        const panelId = clickedButton.getAttribute("aria-controls");
        const targetPanel = this.querySelector(`#${panelId}`);
        if (targetPanel) {
            targetPanel.classList.add("is-active");
            targetPanel.removeAttribute("hidden");
        }
    }
    handleKeydown(event) {
        const target = event.target;
        const tabArray = Array.from(this.tabButtons);
        const index = tabArray.indexOf(target);
        let newIndex;
        switch(event.key){
            case "ArrowLeft":
                newIndex = index === 0 ? tabArray.length - 1 : index - 1;
                tabArray[newIndex].focus();
                tabArray[newIndex].click();
                event.preventDefault();
                break;
            case "ArrowRight":
                newIndex = index === tabArray.length - 1 ? 0 : index + 1;
                tabArray[newIndex].focus();
                tabArray[newIndex].click();
                event.preventDefault();
                break;
            case "Home":
                tabArray[0].focus();
                tabArray[0].click();
                event.preventDefault();
                break;
            case "End":
                tabArray[tabArray.length - 1].focus();
                tabArray[tabArray.length - 1].click();
                event.preventDefault();
                break;
        }
    }
}

},{"../globals/module-class":"2nrKQ","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"5Cdzw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "socialCarousel", ()=>socialCarousel);
var _moduleClass = require("../globals/module-class");
var _carouselManager = require("../utils/CarouselManager");
class SocialCarouselManager extends (0, _moduleClass.FLModule) {
    constructor(){
        super("socialCarouselManager");
    }
    init() {
        document.addEventListener("DOMContentLoaded", ()=>{
            const socialSections = document.querySelectorAll(".shopify-section--social-carousel");
            socialSections.forEach((section)=>{
                const sectionId = section.id;
                const carousel = section.querySelector(".social-carousel__carousel");
                (0, _carouselManager.carouselManager).initCarousel(carousel, sectionId, {
                    defaultConfig: {
                        cellAlign: "center",
                        contain: true,
                        pageDots: false,
                        prevNextButtons: false,
                        wrapAround: true,
                        freeScroll: true
                    }
                });
            });
        });
    }
}
const socialCarousel = new SocialCarouselManager();

},{"../globals/module-class":"2nrKQ","../utils/CarouselManager":"izVcm","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"izVcm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CarouselManager", ()=>CarouselManager);
parcelHelpers.export(exports, "carouselManager", ()=>carouselManager);
var _flickity = require("flickity");
var _flickityDefault = parcelHelpers.interopDefault(_flickity);
var _debounce = require("./debounce");
class CarouselManager {
    /**
   * Initializes the carousel with the given configuration and breakpoint support.
   */ initCarousel(element, sectionId, initConfig) {
        if (this.carousels[sectionId]) this.destroyCarousel(sectionId);
        const section = document.getElementById(sectionId);
        if (!section) return undefined;
        const carouselData = {
            element,
            sectionId,
            initConfig,
            nextArrows: [],
            prevArrows: [],
            resizeHandler: (0, _debounce.debounce)(()=>this.handleResize(sectionId), 100)
        };
        this.carousels[sectionId] = carouselData;
        window.addEventListener("resize", carouselData.resizeHandler);
        // Perform initial setup
        const screenWidth = window.innerWidth;
        const activeConfig = this.getActiveConfig(initConfig, screenWidth);
        if (activeConfig) this.initializeCarousel(sectionId, activeConfig.config, activeConfig.breakpoint);
        return carouselData.instance;
    }
    /**
   * Handles screen resize, reinitializing the carousel if the breakpoint changes.
   */ handleResize(sectionId) {
        const carouselData = this.carousels[sectionId];
        if (!carouselData) return;
        const screenWidth = window.innerWidth;
        const newActive = this.getActiveConfig(carouselData.initConfig, screenWidth);
        if (newActive?.breakpoint !== carouselData.currentBreakpoint) {
            if (carouselData.instance) this.destroyCurrentCarousel(sectionId);
            if (newActive) this.initializeCarousel(sectionId, newActive.config, newActive.breakpoint);
            else carouselData.currentBreakpoint = undefined;
        }
        if (carouselData.instance && carouselData.currentBreakpoint) {
            const config = this.getActiveConfig(carouselData.initConfig, screenWidth)?.config;
            config?.onResize?.(carouselData.instance, [
                carouselData.element,
                sectionId,
                carouselData.initConfig
            ]);
        }
    }
    /**
   * Determines the active configuration based on screen width.
   */ getActiveConfig(initConfig, screenWidth) {
        if (!initConfig.breakpoints || Object.keys(initConfig.breakpoints).length === 0) return {
            config: initConfig.defaultConfig,
            breakpoint: "default"
        };
        const breakpoints = Object.keys(initConfig.breakpoints).map(Number).sort((a, b)=>a - b);
        for (const bp of breakpoints){
            if (screenWidth <= bp) return {
                config: initConfig.breakpoints[bp.toString()],
                breakpoint: bp.toString()
            };
        }
        return initConfig.defaultBehavior === "on" ? {
            config: initConfig.defaultConfig,
            breakpoint: "default"
        } : null;
    }
    /**
   * Initializes or reinitializes the carousel with the specified configuration.
   */ initializeCarousel(sectionId, config, breakpoint) {
        const carouselData = this.carousels[sectionId];
        if (!carouselData) return;
        const { element } = carouselData;
        const section = document.getElementById(sectionId);
        if (!section) return;
        const defaultOptions = {
            cellAlign: "left",
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true,
            adaptiveHeight: false
        };
        const mergedOptions = {
            ...defaultOptions,
            ...config
        };
        const flickityInstance = new (0, _flickityDefault.default)(element, mergedOptions);
        carouselData.instance = flickityInstance;
        carouselData.currentBreakpoint = breakpoint;
        flickityInstance.on("select", (index)=>{
            this.updateArrowStates(sectionId);
            config.onSelect?.(index);
        });
        this.initArrows(section, sectionId);
    }
    destroyCurrentCarousel(sectionId) {
        const carouselData = this.carousels[sectionId];
        if (carouselData?.instance) {
            const section = document.getElementById(sectionId);
            if (section && carouselData.clickHandler) section.removeEventListener("click", carouselData.clickHandler);
            carouselData.instance.destroy();
            carouselData.instance = undefined;
            carouselData.clickHandler = undefined;
            carouselData.nextArrows = [];
            carouselData.prevArrows = [];
        }
    }
    destroyCarousel(sectionId) {
        if (this.carousels[sectionId]) {
            this.destroyCurrentCarousel(sectionId);
            window.removeEventListener("resize", this.carousels[sectionId].resizeHandler);
            delete this.carousels[sectionId];
        }
    }
    getCarousel(sectionId) {
        return this.carousels[sectionId]?.instance;
    }
    initArrows(section, sectionId) {
        if (!section || !this.carousels[sectionId]) return;
        const carouselData = this.carousels[sectionId];
        const nextArrows = section.querySelectorAll(".carousel__arrows .next-arrow");
        const prevArrows = section.querySelectorAll(".carousel__arrows .prev-arrow");
        carouselData.nextArrows = Array.from(nextArrows);
        carouselData.prevArrows = Array.from(prevArrows);
        if (carouselData.clickHandler) section.removeEventListener("click", carouselData.clickHandler);
        const clickHandler = (e)=>{
            const target = e.target;
            if (target.closest(".next-arrow")) this.getCarousel(sectionId)?.next();
            else if (target.closest(".prev-arrow")) this.getCarousel(sectionId)?.previous();
        };
        section.addEventListener("click", clickHandler);
        carouselData.clickHandler = clickHandler;
        this.updateArrowStates(sectionId);
    }
    updateArrowStates(sectionId) {
        const carouselData = this.carousels[sectionId];
        if (!carouselData?.instance) return;
        const { instance, nextArrows, prevArrows } = carouselData;
        for (const prevArrow of prevArrows)if (prevArrow) prevArrow.classList.toggle("inactive", instance.selectedIndex === 0);
        for (const nextArrow of nextArrows)if (nextArrow) nextArrow.classList.toggle("inactive", instance.selectedIndex === instance.slides.length - 1);
    }
    constructor(){
        this.carousels = {};
    }
}
const carouselManager = new CarouselManager();

},{"flickity":"cwvTG","./debounce":"caCfY","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"cwvTG":[function(require,module,exports) {
/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */ (function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "./drag",
        "./prev-next-button",
        "./page-dots",
        "./player",
        "./add-remove-cell",
        "./lazyload"
    ], factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory(require("45d87885d6dd21a7"), require("a535405038835ea0"), require("d049de6cd0e398ff"), require("88ca2a44e453763c"), require("86acba33b5cc63f9"), require("700d26461197fed7"), require("92e2bd4c05d42275"));
})(window, function factory(Flickity) {
    return Flickity;
});

},{"45d87885d6dd21a7":"dihzL","a535405038835ea0":"f8qXa","d049de6cd0e398ff":"flNJ1","88ca2a44e453763c":"1b9um","86acba33b5cc63f9":"5ujtP","700d26461197fed7":"KmO6g","92e2bd4c05d42275":"K0eZ0"}],"dihzL":[function(require,module,exports) {
// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "ev-emitter/ev-emitter",
        "get-size/get-size",
        "fizzy-ui-utils/utils",
        "./cell",
        "./slide",
        "./animate"
    ], function(EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
        return factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("74634699985478b3"), require("2e46221cd1568a35"), require("4e15cab931357150"), require("f57bdc3e3f306e5d"), require("e1a1973cf0a85b67"), require("54b47cef1765fd09"));
    else {
        // browser global
        var _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(window, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ "use strict";
    // vars
    var jQuery = window1.jQuery;
    var getComputedStyle = window1.getComputedStyle;
    var console = window1.console;
    function moveElements(elems, toElem) {
        elems = utils.makeArray(elems);
        while(elems.length)toElem.appendChild(elems.shift());
    }
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    var GUID = 0;
    // internal store of all Flickity intances
    var instances = {};
    function Flickity(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error("Bad element for Flickity: " + (queryElement || element));
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            var instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: "center",
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.createMethods = [];
    var proto = Flickity.prototype;
    // inherit EventEmitter
    utils.extend(proto, EvEmitter.prototype);
    proto._create = function() {
        // add id for Flickity.data
        var id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.originSide = this.options.rightToLeft ? "right" : "left";
        // create viewport & slider
        this.viewport = document.createElement("div");
        this.viewport.className = "flickity-viewport";
        this._createSlider();
        if (this.options.resize || this.options.watchCSS) window1.addEventListener("resize", this);
        // add listeners from on option
        for(var eventName in this.options.on){
            var listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        Flickity.createMethods.forEach(function(method) {
            this[method]();
        }, this);
        if (this.options.watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        utils.extend(this.options, opts);
    };
    proto.activate = function() {
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add("flickity-enabled");
        if (this.options.rightToLeft) this.element.classList.add("flickity-rtl");
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        var cellElems = this._filterFindCellElements(this.element.children);
        moveElements(cellElems, this.slider);
        this.viewport.appendChild(this.slider);
        this.element.appendChild(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener("keydown", this);
        }
        this.emitEvent("activate");
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent("ready");
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        var slider = document.createElement("div");
        slider.className = "flickity-slider";
        slider.style[this.originSide] = 0;
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        var cellElems = this._filterFindCellElements(elems);
        // create new Flickity for collection
        var cells = cellElems.map(function(cellElem) {
            return new Cell(cellElem, this);
        }, this);
        return cells;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        var cellX = 0;
        // get cellX
        if (index > 0) {
            var startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        var len = this.cells.length;
        for(var i = index; i < len; i++){
            var cell = this.cells[i];
            cell.setPosition(cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        }
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach(function(cell) {
            cell.getSize();
        });
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) return;
        var slide = new Slide(this);
        this.slides.push(slide);
        var isOriginLeft = this.originSide == "left";
        var nextMargin = isOriginLeft ? "marginRight" : "marginLeft";
        var canCellFit = this._getCanCellFit();
        this.cells.forEach(function(cell, i) {
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);
            if (canCellFit.call(this, i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(this);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        }, this);
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        var groupCells = this.options.groupCells;
        if (!groupCells) return function() {
            return false;
        };
        else if (typeof groupCells == "number") {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            var number = parseInt(groupCells, 10);
            return function(i) {
                return i % number !== 0;
            };
        }
        // default, group by width of slide
        // parse '75%
        var percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
        var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
        return function(i, slideWidth) {
            /* eslint-disable-next-line no-invalid-this */ return slideWidth <= (this.size.innerWidth + 1) * percent;
        };
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    var cellAlignShorthands = {
        // cell align, then based on origin side
        center: {
            left: 0.5,
            right: 0.5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    proto.setCellAlign = function() {
        var shorthand = cellAlignShorthands[this.options.cellAlign];
        this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
    };
    proto.setGallerySize = function() {
        if (this.options.setGallerySize) {
            var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = height + "px";
        }
    };
    proto._getWrapShiftCells = function() {
        // only for wrap-around
        if (!this.options.wrapAround) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        var gapX = this.cursorPosition;
        var cellIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        gapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(gapX, 0, 1);
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        var cells = [];
        while(gapX > 0){
            var cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        if (!this.options.contain || this.options.wrapAround || !this.cells.length) return;
        var isRightToLeft = this.options.rightToLeft;
        var beginMargin = isRightToLeft ? "marginRight" : "marginLeft";
        var endMargin = isRightToLeft ? "marginLeft" : "marginRight";
        var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
        // content is less than gallery size
        var isContentSmaller = contentWidth < this.size.innerWidth;
        // bounds
        var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
        var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
        // contain each cell target
        this.slides.forEach(function(slide) {
            if (isContentSmaller) // all cells fit inside gallery
            slide.target = contentWidth * this.cellAlign;
            else {
                // contain to bounds
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            }
        }, this);
    };
    // -----  ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        var emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? ".flickity" : "";
            var $event = type;
            if (event) {
                // create jQuery event
                var jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.options.wrapAround || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        var prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent("select", null, [
            index
        ]);
        // change event if new index
        if (index != prevIndex) this.dispatchEvent("change", null, [
            index
        ]);
        // old v1 event name, remove in v3
        this.dispatchEvent("cellSelect");
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        var len = this.slides.length;
        var isWrapping = this.options.wrapAround && len > 1;
        if (!isWrapping) return index;
        var wrapIndex = utils.modulo(index, len);
        // go to shortest
        var delta = Math.abs(wrapIndex - this.selectedIndex);
        var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
        var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
        if (!this.isDragSelect && backWrapDelta < delta) index += len;
        else if (!this.isDragSelect && forewardWrapDelta < delta) index -= len;
        // wrap position so slider is within normal area
        if (index < 0) this.x -= this.slideableWidth;
        else if (index >= len) this.x += this.slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        var slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        // Remove in v3?
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        var initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == "string") {
            var cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        var index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        var cell = this.queryCell(value);
        if (!cell) return;
        var index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slides that has cell
        for(var i = 0; i < this.slides.length; i++){
            var slide = this.slides[i];
            var index = slide.cells.indexOf(cell);
            if (index != -1) return i;
        }
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        // loop through cells to get the one that matches
        for(var i = 0; i < this.cells.length; i++){
            var cell = this.cells[i];
            if (cell.element == elem) return cell;
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        var cells = [];
        elems.forEach(function(elem) {
            var cell = this.getCell(elem);
            if (cell) cells.push(cell);
        }, this);
        return cells;
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map(function(cell) {
            return cell.element;
        });
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        var cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        elem = utils.getParent(elem, ".flickity-slider > *");
        return this.getCell(elem);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        var len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements();
        var cellElems = [];
        for(var i = index - adjCount; i <= index + adjCount; i++){
            var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
            var slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == "number") // use number as index
        return this.cells[selector];
        if (typeof selector == "string") {
            // do not select invalid selectors from hash: #123, #/. #791
            if (selector.match(/^[#.]?[\d/]/)) return;
            // use string as selector, get element
            selector = this.element.querySelector(selector);
        }
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent("uiChange");
    };
    // keep focus on element when child UI elements are clicked
    proto.childUIPointerDown = function(event) {
        // HACK iOS does not allow touch events to bubble up?!
        if (event.type != "touchstart") event.preventDefault();
        this.focus();
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, "onresize", 150);
    proto.resize = function() {
        // #1177 disable resize behavior when animating or dragging for iOS 15
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize();
        // wrap values
        if (this.options.wrapAround) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
        this.emitEvent("resize");
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        var selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        var watchOption = this.options.watchCSS;
        if (!watchOption) return;
        var afterContent = getComputedStyle(this.element, ":after").content;
        // activate if :after { content: 'flickity' }
        if (afterContent.indexOf("flickity") != -1) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        // only work if element is in focus
        var isNotFocused = document.activeElement && document.activeElement != this.element;
        if (!this.options.accessibility || isNotFocused) return;
        var handler = Flickity.keyboardHandlers[event.keyCode];
        if (handler) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        // left arrow
        37: function() {
            var leftMethod = this.options.rightToLeft ? "next" : "previous";
            this.uiChange();
            this[leftMethod]();
        },
        // right arrow
        39: function() {
            var rightMethod = this.options.rightToLeft ? "previous" : "next";
            this.uiChange();
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        // TODO remove scrollTo once focus options gets more support
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
        //    #Browser_compatibility
        var prevScrollY = window1.pageYOffset;
        this.element.focus({
            preventScroll: true
        });
        // hack to fix scroll jump after focus, #76
        if (window1.pageYOffset != prevScrollY) window1.scrollTo(window1.pageXOffset, prevScrollY);
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if (!this.isActive) return;
        this.element.classList.remove("flickity-enabled");
        this.element.classList.remove("flickity-rtl");
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach(function(cell) {
            cell.destroy();
        });
        this.element.removeChild(this.viewport);
        // move child elements back into element
        moveElements(this.slider.children, this.element);
        if (this.options.accessibility) {
            this.element.removeAttribute("tabIndex");
            this.element.removeEventListener("keydown", this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent("deactivate");
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener("resize", this);
        this.allOff();
        this.emitEvent("destroy");
        if (jQuery && this.$element) jQuery.removeData(this.element, "flickity");
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    utils.extend(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        var id = elem && elem.flickityGUID;
        return id && instances[id];
    };
    utils.htmlInit(Flickity, "flickity");
    if (jQuery && jQuery.bridget) jQuery.bridget("flickity", Flickity);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

},{"74634699985478b3":"5iOst","2e46221cd1568a35":"5kUPq","4e15cab931357150":"l8sMv","f57bdc3e3f306e5d":"5pkLw","e1a1973cf0a85b67":"leQPa","54b47cef1765fd09":"eEytH"}],"5iOst":[function(require,module,exports) {
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */ /* jshint unused: true, undef: true, strict: true */ (function(global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */ if (typeof define == "function" && define.amd) // AMD - RequireJS
    define(factory);
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != "undefined" ? window : this, function() {
    "use strict";
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return;
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        var index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
    };
    return EvEmitter;
});

},{}],"5kUPq":[function(require,module,exports) {
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */ /* jshint browser: true, strict: true, undef: true, unused: true */ /* globals console: false */ (function(window1, factory) {
    /* jshint strict: false */ /* globals define, module */ if (typeof define == "function" && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    "use strict";
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        var num = parseFloat(value);
        // not a percent like '100%', and a number
        var isValid = value.indexOf("%") == -1 && !isNaN(num);
        return isValid && num;
    }
    function noop() {}
    var logError = typeof console == "undefined" ? noop : function(message) {
        console.error(message);
    };
    // -------------------------- measurements -------------------------- //
    var measurements = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth"
    ];
    var measurementsLength = measurements.length;
    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            size[measurement] = 0;
        }
        return size;
    }
    // -------------------------- getStyle -------------------------- //
    /**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */ function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) logError("Style returned " + style + ". Are you running this code in a hidden iframe on Firefox? " + "See https://bit.ly/getsizebug1");
        return style;
    }
    // -------------------------- setup -------------------------- //
    var isSetup = false;
    var isBoxSizeOuter;
    /**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */ function setup() {
        // setup once
        if (isSetup) return;
        isSetup = true;
        // -------------------------- box sizing -------------------------- //
        /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */ var div = document.createElement("div");
        div.style.width = "200px";
        div.style.padding = "1px 2px 3px 4px";
        div.style.borderStyle = "solid";
        div.style.borderWidth = "1px 2px 3px 4px";
        div.style.boxSizing = "border-box";
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        setup();
        // use querySeletor if elem is string
        if (typeof elem == "string") elem = document.querySelector(elem);
        // do not proceed on non-objects
        if (!elem || typeof elem != "object" || !elem.nodeType) return;
        var style = getStyle(elem);
        // if hidden, everything is 0
        if (style.display == "none") return getZeroSize();
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = size.isBorderBox = style.boxSizing == "border-box";
        // get all measurements
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

},{}],"l8sMv":[function(require,module,exports) {
/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == "function" && define.amd) // AMD
    define([
        "desandro-matches-selector/matches-selector"
    ], function(matchesSelector) {
        return factory(window1, matchesSelector);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("e73e8dfa75ea20f3"));
    else // browser global
    window1.fizzyUIUtils = factory(window1, window1.matchesSelector);
})(window, function factory(window1, matchesSelector) {
    "use strict";
    var utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        for(var prop in b)a[prop] = b[prop];
        return a;
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    var arraySlice = Array.prototype.slice;
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        if (Array.isArray(obj)) // use object if already an array
        return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        var isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike) // convert nodeList to array
        return arraySlice.call(obj);
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == "string") return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        var method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        var ffElems = [];
        elems.forEach(function(elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) return;
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) ffElems.push(elem);
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for(var i = 0; i < childElems.length; i++)ffElems.push(childElems[i]);
        });
        return ffElems;
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[methodName];
        var timeoutName = methodName + "Timeout";
        _class.prototype[methodName] = function() {
            var timeout = this[timeoutName];
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function() {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(callback) {
        var readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(callback);
        else document.addEventListener("DOMContentLoaded", callback);
    };
    // ----- htmlInit ----- //
    // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + "-" + $2;
        }).toLowerCase();
    };
    var console = window1.console;
    /**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */ utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = "data-" + dashedNamespace;
            var dataAttrElems = document.querySelectorAll("[" + dataAttr + "]");
            var jsDashElems = document.querySelectorAll(".js-" + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + "-options";
            var jQuery = window1.jQuery;
            elems.forEach(function(elem) {
                var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
                var options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error("Error parsing " + dataAttr + " on " + elem.className + ": " + error);
                    return;
                }
                // initialize
                var instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

},{"e73e8dfa75ea20f3":"fuP6O"}],"fuP6O":[function(require,module,exports) {
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */ /*jshint browser: true, strict: true, undef: true, unused: true */ (function(window1, factory) {
    /*global define: false, module: false */ "use strict";
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.matchesSelector = factory();
})(window, function factory() {
    "use strict";
    var matchesMethod = function() {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if (ElemProto.matches) return "matches";
        // check un-prefixed
        if (ElemProto.matchesSelector) return "matchesSelector";
        // check vendor prefixes
        var prefixes = [
            "webkit",
            "moz",
            "ms",
            "o"
        ];
        for(var i = 0; i < prefixes.length; i++){
            var prefix = prefixes[i];
            var method = prefix + "MatchesSelector";
            if (ElemProto[method]) return method;
        }
    }();
    return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
    };
});

},{}],"5pkLw":[function(require,module,exports) {
// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "get-size/get-size"
    ], function(getSize) {
        return factory(window1, getSize);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("1436248caf6f5833"));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1, window1.getSize);
    }
})(window, function factory(window1, getSize) {
    "use strict";
    function Cell(elem, parent) {
        this.element = elem;
        this.parent = parent;
        this.create();
    }
    var proto = Cell.prototype;
    proto.create = function() {
        this.element.style.position = "absolute";
        this.element.setAttribute("aria-hidden", "true");
        this.x = 0;
        this.shift = 0;
        this.element.style[this.parent.originSide] = 0;
    };
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.style.position = "";
        var side = this.parent.originSide;
        this.element.style[side] = "";
        this.element.style.transform = "";
        this.element.removeAttribute("aria-hidden");
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.setPosition = function(x) {
        this.x = x;
        this.updateTarget();
        this.renderPosition(x);
    };
    // setDefaultTarget v1 method, backwards compatibility, remove in v3
    proto.updateTarget = proto.setDefaultTarget = function() {
        var marginProperty = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
    };
    proto.renderPosition = function(x) {
        // render position of cell with in slider
        var sideOffset = this.parent.originSide === "left" ? 1 : -1;
        var adjustedX = this.parent.options.percentPosition ? x * sideOffset * (this.parent.size.innerWidth / this.size.width) : x * sideOffset;
        this.element.style.transform = "translateX(" + this.parent.getPositionValue(adjustedX) + ")";
    };
    proto.select = function() {
        this.element.classList.add("is-selected");
        this.element.removeAttribute("aria-hidden");
    };
    proto.unselect = function() {
        this.element.classList.remove("is-selected");
        this.element.setAttribute("aria-hidden", "true");
    };
    /**
 * @param {Integer} shift - 0, 1, or -1
 */ proto.wrapShift = function(shift) {
        this.shift = shift;
        this.renderPosition(this.x + this.parent.slideableWidth * shift);
    };
    proto.remove = function() {
        this.element.parentNode.removeChild(this.element);
    };
    return Cell;
});

},{"1436248caf6f5833":"5kUPq"}],"leQPa":[function(require,module,exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(window, function factory() {
    "use strict";
    function Slide(parent) {
        this.parent = parent;
        this.isOriginLeft = parent.originSide == "left";
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    var proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length == 1) {
            this.x = cell.x; // x comes from first cell
            var beginMargin = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = cell.size[beginMargin];
        }
    };
    proto.updateTarget = function() {
        var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft";
        var lastCell = this.getLastCell();
        var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
        var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach(function(cell) {
            cell.select();
        });
    };
    proto.unselect = function() {
        this.cells.forEach(function(cell) {
            cell.unselect();
        });
    };
    proto.getCellElements = function() {
        return this.cells.map(function(cell) {
            return cell.element;
        });
    };
    return Slide;
});

},{}],"eEytH":[function(require,module,exports) {
// animate
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "fizzy-ui-utils/utils"
    ], function(utils) {
        return factory(window1, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("a7f521c88137c405"));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1, window1.fizzyUIUtils);
    }
})(window, function factory(window1, utils) {
    "use strict";
    // -------------------------- animate -------------------------- //
    var proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        var previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) {
            var _this = this;
            requestAnimationFrame(function animateFrame() {
                _this.animate();
            });
        }
    };
    proto.positionSlider = function() {
        var x = this.x;
        // wrap position around
        if (this.options.wrapAround && this.cells.length > 1) {
            x = utils.modulo(x, this.slideableWidth);
            x -= this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        x = this.options.rightToLeft ? -x : x;
        var translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? "translate3d(" + translateX + ",0,0)" : "translateX(" + translateX + ")";
    };
    proto.dispatchScrollEvent = function() {
        var firstSlide = this.slides[0];
        if (!firstSlide) return;
        var positionX = -this.x - firstSlide.target;
        var progress = positionX / this.slidesWidth;
        this.dispatchEvent("scroll", null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + "%";
        else // pixel positioning
        return Math.round(position) + "px";
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        var isResting = !this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent("settle", null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        var beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        for(var i = 0; i < cells.length; i++){
            var cell = cells[i];
            var cellShift = gap > 0 ? shift : 0;
            cell.wrapShift(cellShift);
            gap -= cell.size.outerWidth;
        }
    };
    proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        for(var i = 0; i < cells.length; i++)cells[i].wrapShift(0);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        var dragVelocity = this.dragX - this.x;
        var dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        var dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        var distance = this.selectedSlide.target * -1 - this.x;
        var force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

},{"a7f521c88137c405":"l8sMv"}],"f8qXa":[function(require,module,exports) {
// drag
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "unidragger/unidragger",
        "fizzy-ui-utils/utils"
    ], function(Flickity, Unidragger, utils) {
        return factory(window1, Flickity, Unidragger, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("a039263f0cc9bf59"), require("b916d2c8026055e5"), require("fb90901d0d899a74"));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unidragger, utils) {
    "use strict";
    // ----- defaults ----- //
    utils.extend(Flickity.defaults, {
        draggable: ">1",
        dragThreshold: 3
    });
    // ----- create ----- //
    Flickity.createMethods.push("_createDrag");
    // -------------------------- drag prototype -------------------------- //
    var proto = Flickity.prototype;
    utils.extend(proto, Unidragger.prototype);
    proto._touchActionValue = "pan-y";
    // --------------------------  -------------------------- //
    proto._createDrag = function() {
        this.on("activate", this.onActivateDrag);
        this.on("uiChange", this._uiChangeDrag);
        this.on("deactivate", this.onDeactivateDrag);
        this.on("cellChange", this.updateDraggable);
    // TODO updateDraggable on resize? if groupCells & slides change
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove("is-draggable");
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable == ">1") this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        if (this.isDraggable) this.element.classList.add("is-draggable");
        else this.element.classList.remove("is-draggable");
    };
    // backwards compatibility
    proto.bindDrag = function() {
        this.options.draggable = true;
        this.updateDraggable();
    };
    proto.unbindDrag = function() {
        this.options.draggable = false;
        this.updateDraggable();
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.pointerDown = function(event, pointer) {
        if (!this.isDraggable) {
            this._pointerDownDefault(event, pointer);
            return;
        }
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) return;
        this._pointerDownPreventDefault(event);
        this.pointerDownFocus(event);
        // blur
        if (document.activeElement != this.element) // do not blur if already focused
        this.pointerDownBlur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add("is-pointer-down");
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener("scroll", this);
        this._pointerDownDefault(event, pointer);
    };
    // default pointerDown logic, used for staticClick
    proto._pointerDownDefault = function(event, pointer) {
        // track start event position
        // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        // bind move and end events
        this._bindPostStartEvents(event);
        this.dispatchEvent("pointerDown", event, [
            pointer
        ]);
    };
    var focusNodes = {
        INPUT: true,
        TEXTAREA: true,
        SELECT: true
    };
    proto.pointerDownFocus = function(event) {
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isFocusNode) this.focus();
    };
    proto._pointerDownPreventDefault = function(event) {
        var isTouchStart = event.type == "touchstart";
        var isTouchPointer = event.pointerType == "touch";
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.pointerUp = function(event, pointer) {
        delete this.isTouchScrolling;
        this.viewport.classList.remove("is-pointer-down");
        this.dispatchEvent("pointerUp", event, [
            pointer
        ]);
        this._dragPointerUp(event, pointer);
    };
    proto.pointerDone = function() {
        window1.removeEventListener("scroll", this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.dragStart = function(event, pointer) {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener("scroll", this);
        this.dispatchEvent("dragStart", event, [
            pointer
        ]);
    };
    proto.pointerMove = function(event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.dispatchEvent("pointerMove", event, [
            pointer,
            moveVector
        ]);
        this._dragMove(event, pointer, moveVector);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        var direction = this.options.rightToLeft ? -1 : 1;
        if (this.options.wrapAround) // wrap around move. #589
        moveVector.x %= this.slideableWidth;
        var dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.options.wrapAround && this.slides.length) {
            // slow drag
            var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
        this.dispatchEvent("dragMove", event, [
            pointer,
            moveVector
        ]);
    };
    proto.dragEnd = function(event, pointer) {
        if (!this.isDraggable) return;
        if (this.options.freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        var index = this.dragEndRestingSelect();
        if (this.options.freeScroll && !this.options.wrapAround) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            var restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!this.options.freeScroll && index == this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // TODO refactor this, selecting here feels weird
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.options.wrapAround;
        this.select(index);
        delete this.isDragSelect;
        this.dispatchEvent("dragEnd", event, [
            pointer
        ]);
    };
    proto.dragEndRestingSelect = function() {
        var restingX = this.getRestingPosition();
        // how far away from selected slide
        var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        var positiveResting = this._getClosestResting(restingX, distance, 1);
        var negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
        return index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        var index = this.selectedIndex;
        var minDistance = Infinity;
        var condition = this.options.contain && !this.options.wrapAround ? // if contain, keep going if distance is equal to minDistance
        function(dist, minDist) {
            return dist <= minDist;
        } : function(dist, minDist) {
            return dist < minDist;
        };
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        var len = this.slides.length;
        // wrap around if at least 2 slides
        var isWrapAround = this.options.wrapAround && len > 1;
        var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        var slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        var delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- staticClick ----- //
    proto.staticClick = function(event, pointer) {
        // get clickedCell, if cell was clicked
        var clickedCell = this.getParentCell(event.target);
        var cellElem = clickedCell && clickedCell.element;
        var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
        this.dispatchEvent("staticClick", event, [
            pointer,
            cellElem,
            cellIndex
        ]);
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        var scroll = getScrollPosition();
        var scrollMoveX = this.pointerDownScroll.x - scroll.x;
        var scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this._pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

},{"a039263f0cc9bf59":"dihzL","b916d2c8026055e5":"1wpoh","fb90901d0d899a74":"l8sMv"}],"1wpoh":[function(require,module,exports) {
/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */ /*jshint browser: true, unused: true, undef: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == "function" && define.amd) // AMD
    define([
        "unipointer/unipointer"
    ], function(Unipointer) {
        return factory(window1, Unipointer);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("ccb94d3e845de8ec"));
    else // browser global
    window1.Unidragger = factory(window1, window1.Unipointer);
})(window, function factory(window1, Unipointer) {
    "use strict";
    // -------------------------- Unidragger -------------------------- //
    function Unidragger() {}
    // inherit Unipointer & EvEmitter
    var proto = Unidragger.prototype = Object.create(Unipointer.prototype);
    // ----- bind start ----- //
    proto.bindHandles = function() {
        this._bindHandles(true);
    };
    proto.unbindHandles = function() {
        this._bindHandles(false);
    };
    /**
 * Add or remove start event
 * @param {Boolean} isAdd
 */ proto._bindHandles = function(isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        // bind each handle
        var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
        var touchAction = isAdd ? this._touchActionValue : "";
        for(var i = 0; i < this.handles.length; i++){
            var handle = this.handles[i];
            this._bindStartEvent(handle, isAdd);
            handle[bindMethod]("click", this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        }
    };
    // prototype so it can be overwriteable by Flickity
    proto._touchActionValue = "none";
    // ----- start event ----- //
    /**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) return;
        // track start event position
        // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        event.preventDefault();
        this.pointerDownBlur();
        // bind move and end events
        this._bindPostStartEvents(event);
        this.emitEvent("pointerDown", [
            event,
            pointer
        ]);
    };
    // nodes that have text fields
    var cursorNodes = {
        TEXTAREA: true,
        INPUT: true,
        SELECT: true,
        OPTION: true
    };
    // input types that do not have text fields
    var clickTypes = {
        radio: true,
        checkbox: true,
        button: true,
        submit: true,
        image: true,
        file: true
    };
    // dismiss inputs with text fields. flickity#403, flickity#404
    proto.okayPointerDown = function(event) {
        var isCursorNode = cursorNodes[event.target.nodeName];
        var isClickType = clickTypes[event.target.type];
        var isOkay = !isCursorNode || isClickType;
        if (!isOkay) this._pointerReset();
        return isOkay;
    };
    // kludge to blur previously focused input
    proto.pointerDownBlur = function() {
        var focused = document.activeElement;
        // do not blur body for IE10, metafizzy/flickity#117
        var canBlur = focused && focused.blur && focused != document.body;
        if (canBlur) focused.blur();
    };
    // ----- move event ----- //
    /**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerMove = function(event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.emitEvent("pointerMove", [
            event,
            pointer,
            moveVector
        ]);
        this._dragMove(event, pointer, moveVector);
    };
    // base pointer move logic
    proto._dragPointerMove = function(event, pointer) {
        var moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        // start drag if pointer has moved far enough to start drag
        if (!this.isDragging && this.hasDragStarted(moveVector)) this._dragStart(event, pointer);
        return moveVector;
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- end event ----- //
    /**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerUp = function(event, pointer) {
        this.emitEvent("pointerUp", [
            event,
            pointer
        ]);
        this._dragPointerUp(event, pointer);
    };
    proto._dragPointerUp = function(event, pointer) {
        if (this.isDragging) this._dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this._staticClick(event, pointer);
    };
    // -------------------------- drag -------------------------- //
    // dragStart
    proto._dragStart = function(event, pointer) {
        this.isDragging = true;
        // prevent clicks
        this.isPreventingClicks = true;
        this.dragStart(event, pointer);
    };
    proto.dragStart = function(event, pointer) {
        this.emitEvent("dragStart", [
            event,
            pointer
        ]);
    };
    // dragMove
    proto._dragMove = function(event, pointer, moveVector) {
        // do not drag if not dragging yet
        if (!this.isDragging) return;
        this.dragMove(event, pointer, moveVector);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        event.preventDefault();
        this.emitEvent("dragMove", [
            event,
            pointer,
            moveVector
        ]);
    };
    // dragEnd
    proto._dragEnd = function(event, pointer) {
        // set flags
        this.isDragging = false;
        // re-enable clicking async
        setTimeout((function() {
            delete this.isPreventingClicks;
        }).bind(this));
        this.dragEnd(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        this.emitEvent("dragEnd", [
            event,
            pointer
        ]);
    };
    // ----- onclick ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // ----- staticClick ----- //
    // triggered after pointer down & up with no/tiny movement
    proto._staticClick = function(event, pointer) {
        // ignore emulated mouse up clicks
        if (this.isIgnoringMouseUp && event.type == "mouseup") return;
        this.staticClick(event, pointer);
        // set flag for emulated clicks 300ms after touchend
        if (event.type != "mouseup") {
            this.isIgnoringMouseUp = true;
            // reset flag after 300ms
            setTimeout((function() {
                delete this.isIgnoringMouseUp;
            }).bind(this), 400);
        }
    };
    proto.staticClick = function(event, pointer) {
        this.emitEvent("staticClick", [
            event,
            pointer
        ]);
    };
    // ----- utils ----- //
    Unidragger.getPointerPoint = Unipointer.getPointerPoint;
    // -----  ----- //
    return Unidragger;
});

},{"ccb94d3e845de8ec":"jwMYe"}],"jwMYe":[function(require,module,exports) {
/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /* jshint strict: false */ /*global define, module, require */ if (typeof define == "function" && define.amd) // AMD
    define([
        "ev-emitter/ev-emitter"
    ], function(EvEmitter) {
        return factory(window1, EvEmitter);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("e0190396ab68f088"));
    else // browser global
    window1.Unipointer = factory(window1, window1.EvEmitter);
})(window, function factory(window1, EvEmitter) {
    "use strict";
    function noop() {}
    function Unipointer() {}
    // inherit EvEmitter
    var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);
    proto.bindStartEvent = function(elem) {
        this._bindStartEvent(elem, true);
    };
    proto.unbindStartEvent = function(elem) {
        this._bindStartEvent(elem, false);
    };
    /**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */ proto._bindStartEvent = function(elem, isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
        // default to mouse events
        var startEvent = "mousedown";
        if ("ontouchstart" in window1) // HACK prefer Touch Events as you can preventDefault on touchstart to
        // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
        startEvent = "touchstart";
        else if (window1.PointerEvent) // Pointer Events
        startEvent = "pointerdown";
        elem[bindMethod](startEvent, this);
    };
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        var method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    // returns the touch that we're keeping track of
    proto.getTouch = function(touches) {
        for(var i = 0; i < touches.length; i++){
            var touch = touches[i];
            if (touch.identifier == this.pointerIdentifier) return touch;
        }
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        // dismiss clicks from right or middle buttons
        var button = event.button;
        if (button && button !== 0 && button !== 1) return;
        this._pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this._pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this._pointerDown(event, event);
    };
    /**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto._pointerDown = function(event, pointer) {
        // dismiss right click and other pointers
        // button = 0 is okay, 1-4 not
        if (event.button || this.isPointerDown) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        this.pointerDown(event, pointer);
    };
    proto.pointerDown = function(event, pointer) {
        this._bindPostStartEvents(event);
        this.emitEvent("pointerDown", [
            event,
            pointer
        ]);
    };
    // hash of events to be bound after start event
    var postStartEvents = {
        mousedown: [
            "mousemove",
            "mouseup"
        ],
        touchstart: [
            "touchmove",
            "touchend",
            "touchcancel"
        ],
        pointerdown: [
            "pointermove",
            "pointerup",
            "pointercancel"
        ]
    };
    proto._bindPostStartEvents = function(event) {
        if (!event) return;
        // get proper events to match start event
        var events = postStartEvents[event.type];
        // bind events to node
        events.forEach(function(eventName) {
            window1.addEventListener(eventName, this);
        }, this);
        // save these arguments
        this._boundPointerEvents = events;
    };
    proto._unbindPostStartEvents = function() {
        // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
        if (!this._boundPointerEvents) return;
        this._boundPointerEvents.forEach(function(eventName) {
            window1.removeEventListener(eventName, this);
        }, this);
        delete this._boundPointerEvents;
    };
    // ----- move event ----- //
    proto.onmousemove = function(event) {
        this._pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerMove(event, event);
    };
    proto.ontouchmove = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerMove(event, touch);
    };
    /**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerMove = function(event, pointer) {
        this.pointerMove(event, pointer);
    };
    // public
    proto.pointerMove = function(event, pointer) {
        this.emitEvent("pointerMove", [
            event,
            pointer
        ]);
    };
    // ----- end event ----- //
    proto.onmouseup = function(event) {
        this._pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerUp(event, event);
    };
    proto.ontouchend = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerUp(event, touch);
    };
    /**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerUp = function(event, pointer) {
        this._pointerDone();
        this.pointerUp(event, pointer);
    };
    // public
    proto.pointerUp = function(event, pointer) {
        this.emitEvent("pointerUp", [
            event,
            pointer
        ]);
    };
    // ----- pointer done ----- //
    // triggered on pointer up & pointer cancel
    proto._pointerDone = function() {
        this._pointerReset();
        this._unbindPostStartEvents();
        this.pointerDone();
    };
    proto._pointerReset = function() {
        // reset properties
        this.isPointerDown = false;
        delete this.pointerIdentifier;
    };
    proto.pointerDone = noop;
    // ----- pointer cancel ----- //
    proto.onpointercancel = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerCancel(event, event);
    };
    proto.ontouchcancel = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerCancel(event, touch);
    };
    /**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerCancel = function(event, pointer) {
        this._pointerDone();
        this.pointerCancel(event, pointer);
    };
    // public
    proto.pointerCancel = function(event, pointer) {
        this.emitEvent("pointerCancel", [
            event,
            pointer
        ]);
    };
    // -----  ----- //
    // utility function for getting x/y coords from event
    Unipointer.getPointerPoint = function(pointer) {
        return {
            x: pointer.pageX,
            y: pointer.pageY
        };
    };
    // -----  ----- //
    return Unipointer;
});

},{"e0190396ab68f088":"5iOst"}],"flNJ1":[function(require,module,exports) {
// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "unipointer/unipointer",
        "fizzy-ui-utils/utils"
    ], function(Flickity, Unipointer, utils) {
        return factory(window1, Flickity, Unipointer, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("6eb257b6fa1f2734"), require("9f3bfcdbed37c8f0"), require("9ba9e2fd183c8dc1"));
    else // browser global
    factory(window1, window1.Flickity, window1.Unipointer, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unipointer, utils) {
    "use strict";
    var svgURI = "http://www.w3.org/2000/svg";
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(direction, parent) {
        this.direction = direction;
        this.parent = parent;
        this._create();
    }
    PrevNextButton.prototype = Object.create(Unipointer.prototype);
    PrevNextButton.prototype._create = function() {
        // properties
        this.isEnabled = true;
        this.isPrevious = this.direction == -1;
        var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == leftDirection;
        var element = this.element = document.createElement("button");
        element.className = "flickity-button flickity-prev-next-button";
        element.className += this.isPrevious ? " previous" : " next";
        // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
        element.setAttribute("type", "button");
        // init as disabled
        this.disable();
        element.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        // create arrow
        var svg = this.createSVG();
        element.appendChild(svg);
        // events
        this.parent.on("select", this.update.bind(this));
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    };
    PrevNextButton.prototype.activate = function() {
        this.bindStartEvent(this.element);
        this.element.addEventListener("click", this);
        // add to DOM
        this.parent.element.appendChild(this.element);
    };
    PrevNextButton.prototype.deactivate = function() {
        // remove from DOM
        this.parent.element.removeChild(this.element);
        // click events
        this.unbindStartEvent(this.element);
        this.element.removeEventListener("click", this);
    };
    PrevNextButton.prototype.createSVG = function() {
        var svg = document.createElementNS(svgURI, "svg");
        svg.setAttribute("class", "flickity-button-icon");
        svg.setAttribute("viewBox", "0 0 100 100");
        var path = document.createElementNS(svgURI, "path");
        var pathMovements = getArrowMovements(this.parent.options.arrowShape);
        path.setAttribute("d", pathMovements);
        path.setAttribute("class", "arrow");
        // rotate arrow
        if (!this.isLeft) path.setAttribute("transform", "translate(100, 100) rotate(180) ");
        svg.appendChild(path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == "string") return shape;
        // create movement string
        return "M " + shape.x0 + ",50" + " L " + shape.x1 + "," + (shape.y1 + 50) + " L " + shape.x2 + "," + (shape.y2 + 50) + " L " + shape.x3 + ",50 " + " L " + shape.x2 + "," + (50 - shape.y2) + " L " + shape.x1 + "," + (50 - shape.y1) + " Z";
    }
    PrevNextButton.prototype.handleEvent = utils.handleEvent;
    PrevNextButton.prototype.onclick = function() {
        if (!this.isEnabled) return;
        this.parent.uiChange();
        var method = this.isPrevious ? "previous" : "next";
        this.parent[method]();
    };
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        if (this.isEnabled) return;
        this.element.disabled = false;
        this.isEnabled = true;
    };
    PrevNextButton.prototype.disable = function() {
        if (!this.isEnabled) return;
        this.element.disabled = true;
        this.isEnabled = false;
    };
    PrevNextButton.prototype.update = function() {
        // index of first or last slide, if previous or next
        var slides = this.parent.slides;
        // enable is wrapAround and at least 2 slides
        if (this.parent.options.wrapAround && slides.length > 1) {
            this.enable();
            return;
        }
        var lastIndex = slides.length ? slides.length - 1 : 0;
        var boundIndex = this.isPrevious ? 0 : lastIndex;
        var method = this.parent.selectedIndex == boundIndex ? "disable" : "enable";
        this[method]();
    };
    PrevNextButton.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
    };
    // -------------------------- Flickity prototype -------------------------- //
    utils.extend(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.createMethods.push("_createPrevNextButtons");
    var proto = Flickity.prototype;
    proto._createPrevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        this.prevButton = new PrevNextButton(-1, this);
        this.nextButton = new PrevNextButton(1, this);
        this.on("activate", this.activatePrevNextButtons);
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.activate();
        this.nextButton.activate();
        this.on("deactivate", this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate();
        this.nextButton.deactivate();
        this.off("deactivate", this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

},{"6eb257b6fa1f2734":"dihzL","9f3bfcdbed37c8f0":"jwMYe","9ba9e2fd183c8dc1":"l8sMv"}],"1b9um":[function(require,module,exports) {
// page dots
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "unipointer/unipointer",
        "fizzy-ui-utils/utils"
    ], function(Flickity, Unipointer, utils) {
        return factory(window1, Flickity, Unipointer, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("6b21fdf806bb1ced"), require("56a5b2bec5ad98ff"), require("6ca5a07469342816"));
    else // browser global
    factory(window1, window1.Flickity, window1.Unipointer, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unipointer, utils) {
    // -------------------------- PageDots -------------------------- //
    "use strict";
    function PageDots(parent) {
        this.parent = parent;
        this._create();
    }
    PageDots.prototype = Object.create(Unipointer.prototype);
    PageDots.prototype._create = function() {
        // create holder element
        this.holder = document.createElement("ol");
        this.holder.className = "flickity-page-dots";
        // create dots, array of elements
        this.dots = [];
        // events
        this.handleClick = this.onClick.bind(this);
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    };
    PageDots.prototype.activate = function() {
        this.setDots();
        this.holder.addEventListener("click", this.handleClick);
        this.bindStartEvent(this.holder);
        // add to DOM
        this.parent.element.appendChild(this.holder);
    };
    PageDots.prototype.deactivate = function() {
        this.holder.removeEventListener("click", this.handleClick);
        this.unbindStartEvent(this.holder);
        // remove from DOM
        this.parent.element.removeChild(this.holder);
    };
    PageDots.prototype.setDots = function() {
        // get difference between number of slides and number of dots
        var delta = this.parent.slides.length - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        var fragment = document.createDocumentFragment();
        var newDots = [];
        var length = this.dots.length;
        var max = length + count;
        for(var i = length; i < max; i++){
            var dot = document.createElement("li");
            dot.className = "dot";
            dot.setAttribute("aria-label", "Page dot " + (i + 1));
            fragment.appendChild(dot);
            newDots.push(dot);
        }
        this.holder.appendChild(fragment);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        var removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach(function(dot) {
            this.holder.removeChild(dot);
        }, this);
    };
    PageDots.prototype.updateSelected = function() {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.className = "dot";
            this.selectedDot.removeAttribute("aria-current");
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[this.parent.selectedIndex];
        this.selectedDot.className = "dot is-selected";
        this.selectedDot.setAttribute("aria-current", "step");
    };
    PageDots.prototype.onTap = PageDots.prototype.onClick = function(event) {
        var target = event.target;
        // only care about dot clicks
        if (target.nodeName != "LI") return;
        this.parent.uiChange();
        var index = this.dots.indexOf(target);
        this.parent.select(index);
    };
    PageDots.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    utils.extend(Flickity.defaults, {
        pageDots: true
    });
    Flickity.createMethods.push("_createPageDots");
    var proto = Flickity.prototype;
    proto._createPageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots(this);
        // events
        this.on("activate", this.activatePageDots);
        this.on("select", this.updateSelectedPageDots);
        this.on("cellChange", this.updatePageDots);
        this.on("resize", this.updatePageDots);
        this.on("deactivate", this.deactivatePageDots);
    };
    proto.activatePageDots = function() {
        this.pageDots.activate();
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected();
    };
    proto.updatePageDots = function() {
        this.pageDots.setDots();
    };
    proto.deactivatePageDots = function() {
        this.pageDots.deactivate();
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

},{"6b21fdf806bb1ced":"dihzL","56a5b2bec5ad98ff":"jwMYe","6ca5a07469342816":"l8sMv"}],"5ujtP":[function(require,module,exports) {
// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "ev-emitter/ev-emitter",
        "fizzy-ui-utils/utils",
        "./flickity"
    ], function(EvEmitter, utils, Flickity) {
        return factory(EvEmitter, utils, Flickity);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(require("e46165b85865a5d4"), require("5e96262ff142690"), require("e859b105d5b2767d"));
    else // browser global
    factory(window1.EvEmitter, window1.fizzyUIUtils, window1.Flickity);
})(window, function factory(EvEmitter, utils, Flickity) {
    "use strict";
    // -------------------------- Player -------------------------- //
    function Player(parent) {
        this.parent = parent;
        this.state = "stopped";
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    Player.prototype = Object.create(EvEmitter.prototype);
    // start play
    Player.prototype.play = function() {
        if (this.state == "playing") return;
        // do not play if page is hidden, start playing when page is visible
        var isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener("visibilitychange", this.onVisibilityPlay);
            return;
        }
        this.state = "playing";
        // listen to visibility change
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        // do not tick if not playing
        if (this.state != "playing") return;
        var time = this.parent.options.autoPlay;
        // default to 3 seconds
        time = typeof time == "number" ? time : 3000;
        var _this = this;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(function() {
            _this.parent.next(true);
            _this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = "stopped";
        this.clear();
        // remove visibility change event
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state == "playing") {
            this.state = "paused";
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state == "paused") this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        var isPageHidden = document.hidden;
        this[isPageHidden ? "pause" : "unpause"]();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener("visibilitychange", this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    utils.extend(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.createMethods.push("_createPlayer");
    var proto = Flickity.prototype;
    proto._createPlayer = function() {
        this.player = new Player(this);
        this.on("activate", this.activatePlayer);
        this.on("uiChange", this.stopPlayer);
        this.on("pointerDown", this.stopPlayer);
        this.on("deactivate", this.deactivatePlayer);
    };
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener("mouseenter", this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener("mouseenter", this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener("mouseleave", this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener("mouseleave", this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

},{"e46165b85865a5d4":"5iOst","5e96262ff142690":"l8sMv","e859b105d5b2767d":"dihzL"}],"KmO6g":[function(require,module,exports) {
// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "fizzy-ui-utils/utils"
    ], function(Flickity, utils) {
        return factory(window1, Flickity, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("360f68a6f8140eb3"), require("62e27dbaf1919098"));
    else // browser global
    factory(window1, window1.Flickity, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, utils) {
    "use strict";
    // append cells to a document fragment
    function getCellsFragment(cells) {
        var fragment = document.createDocumentFragment();
        cells.forEach(function(cell) {
            fragment.appendChild(cell.element);
        });
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    var proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        var cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        var len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        var fragment = getCellsFragment(cells);
        // append to slider
        var isAppend = index == len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            var insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            var endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index, true);
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        var cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        var minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach(function(cell) {
            cell.remove();
            var index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        }, this);
        this.cellChange(minCellIndex, true);
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        var cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        var index = this.cells.indexOf(cell);
        this.cellChange(index);
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 * @param {Boolean} isPositioningSlider - Positions slider after selection
 */ proto.cellChange = function(changedCellIndex, isPositioningSlider) {
        var prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._getWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex
        // try to maintain position & select previous selected element
        var cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent("cellChange", [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
        // do not position slider after lazy load
        if (isPositioningSlider) this.positionSliderAtSelected();
    };
    // -----  ----- //
    return Flickity;
});

},{"360f68a6f8140eb3":"dihzL","62e27dbaf1919098":"l8sMv"}],"K0eZ0":[function(require,module,exports) {
// lazyload
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "fizzy-ui-utils/utils"
    ], function(Flickity, utils) {
        return factory(window1, Flickity, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, require("5e8432ce8dcebfb2"), require("6521fc8e9a273f4e"));
    else // browser global
    factory(window1, window1.Flickity, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, utils) {
    "use strict";
    Flickity.createMethods.push("_createLazyload");
    var proto = Flickity.prototype;
    proto._createLazyload = function() {
        this.on("select", this.lazyLoad);
    };
    proto.lazyLoad = function() {
        var lazyLoad = this.options.lazyLoad;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
        var cellElems = this.getAdjacentCellElements(adjCount);
        // get lazy images in those cells
        var lazyImages = [];
        cellElems.forEach(function(cellElem) {
            var lazyCellImages = getCellLazyImages(cellElem);
            lazyImages = lazyImages.concat(lazyCellImages);
        });
        // load lazy images
        lazyImages.forEach(function(img) {
            new LazyLoader(img, this);
        }, this);
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.nodeName == "IMG") {
            var lazyloadAttr = cellElem.getAttribute("data-flickity-lazyload");
            var srcAttr = cellElem.getAttribute("data-flickity-lazyload-src");
            var srcsetAttr = cellElem.getAttribute("data-flickity-lazyload-srcset");
            if (lazyloadAttr || srcAttr || srcsetAttr) return [
                cellElem
            ];
        }
        // select lazy images in cell
        var lazySelector = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
        var imgs = cellElem.querySelectorAll(lazySelector);
        return utils.makeArray(imgs);
    }
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Flickity} flickity - Flickity instance
 */ function LazyLoader(img, flickity) {
        this.img = img;
        this.flickity = flickity;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        // get src & srcset
        var src = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src");
        var srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute("srcset", srcset);
        // remove attr
        this.img.removeAttribute("data-flickity-lazyload");
        this.img.removeAttribute("data-flickity-lazyload-src");
        this.img.removeAttribute("data-flickity-lazyload-srcset");
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, "flickity-lazyloaded");
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, "flickity-lazyerror");
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
        var cell = this.flickity.getParentCell(this.img);
        var cellElem = cell && cell.element;
        this.flickity.cellSizeChange(cellElem);
        this.img.classList.add(className);
        this.flickity.dispatchEvent("lazyLoad", event, cellElem);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

},{"5e8432ce8dcebfb2":"dihzL","6521fc8e9a273f4e":"l8sMv"}],"caCfY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = ()=>{
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"lTyqw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cardCarousel", ()=>cardCarousel);
var _moduleClass = require("../globals/module-class");
var _carouselManager = require("../utils/CarouselManager");
class CardCarouselManager extends (0, _moduleClass.FLModule) {
    constructor(){
        super("cardCarouselManager");
    }
    init() {
        document.addEventListener("DOMContentLoaded", ()=>{
            const cardSections = document.querySelectorAll(".shopify-section--card-carousel");
            cardSections.forEach((section)=>{
                const sectionId = section.id;
                const carousel = section.querySelector(".card-carousel__track");
                (0, _carouselManager.carouselManager).initCarousel(carousel, sectionId, {
                    defaultConfig: {
                        cellAlign: "center",
                        contain: true,
                        pageDots: false,
                        prevNextButtons: false,
                        dragThreshold: 10,
                        friction: 0.4,
                        wrapAround: true,
                        freeScroll: false,
                        onSelect: ()=>{
                            const slides = carousel.getElementsByClassName("card-carousel__card");
                            requestAnimationFrame(()=>{
                                for(let i = 0; i < slides.length; i++){
                                    // Get all video elements and pause them
                                    const slide = slides[i];
                                    if (slide && !slide.classList.contains("is-selected")) {
                                        const videos = slide.querySelectorAll("video");
                                        videos.forEach((video)=>{
                                            video.pause();
                                        });
                                    }
                                }
                            });
                        },
                        onResize: (carousel)=>{
                            carousel.resize();
                        }
                    }
                });
            });
        });
    }
}
const cardCarousel = new CardCarouselManager();

},{"../globals/module-class":"2nrKQ","../utils/CarouselManager":"izVcm","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"fe4OJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExpandingCards", ()=>ExpandingCards);
parcelHelpers.export(exports, "expandingCards", ()=>expandingCards);
var _moduleClass = require("../globals/module-class");
var _remeda = require("remeda");
var _cardExpansionCalculator = require("../utils/card-expansion-calculator");
const Motion = window.Motion;
const SPRING_CONFIG = {
    mass: 1,
    stiffness: 300,
    damping: 15
};
class ExpandingCards extends (0, _moduleClass.FLModule) {
    constructor(){
        super("ExpandingCards");
        this.isMobile = window.innerWidth < 1024;
        this.cards = document.querySelectorAll(".expanding-card");
        this.carousel = document.querySelector(".expanding-cards__carousel");
        this.prevArrow = document.querySelector(".carousel__arrow.prev-arrow");
        this.nextArrow = document.querySelector(".carousel__arrow.next-arrow");
        // Initialize the card expansion calculator
        this.expansionCalculator = this.createExpansionCalculator();
    }
    /**
   * Create the expansion calculator with proper breakpoints
   */ createExpansionCalculator() {
        // Create the calculator with breakpoints
        return new (0, _cardExpansionCalculator.CardExpansionCalculator)({
            gap: 16,
            defaultExpandedWidth: {
                type: "fixed",
                value: 800
            },
            defaultCollapsedWidth: {
                type: "fixed",
                value: 361
            },
            breakpoints: [
                // Tablet breakpoint
                {
                    maxWidth: 1023,
                    expandedWidth: {
                        type: "percentage",
                        value: 1
                    },
                    collapsedWidth: {
                        type: "percentage",
                        value: 1
                    }
                }
            ]
        });
    }
    init() {
        this.cards = document.querySelectorAll(".expanding-card");
        this.carousel = document.querySelector(".expanding-cards__carousel");
        this.prevArrow = document.querySelector(".carousel__arrow.prev-arrow");
        this.nextArrow = document.querySelector(".carousel__arrow.next-arrow");
        this.bindEvents();
        this.initializeCardStates();
        // Calculate and store expanded widths
        this.updateCardDimensions();
        const saveScrollPositions = ()=>{
            this.cards.forEach((card)=>{
                card.scrollPosition = this.getCardScrollPosition(card);
            });
        };
        saveScrollPositions();
        window.addEventListener("resize", ()=>{
            this.isMobile = window.innerWidth < 1024;
            this.updateCardDimensions();
            saveScrollPositions();
        });
    }
    /**
   * Update card dimensions using the expansion calculator
   */ updateCardDimensions() {
        if (!this.carousel || !this.cards.length) return;
        const carouselWidth = this.carousel.offsetWidth;
        const expandedWidth = this.expansionCalculator.getExpandedWidth(carouselWidth, this.cards.length);
        const collapsedWidth = this.expansionCalculator.getCollapsedWidth(carouselWidth, this.cards.length);
        this.log({
            carouselWidth,
            expandedWidth,
            collapsedWidth
        });
        // Store the expanded width on each card
        this.cards.forEach((card)=>{
            card.expandedWidth = expandedWidth;
            // Apply the appropriate width based on card state
            if (expandedWidth) card.style.setProperty("--expanded-width", `${expandedWidth}px`);
            if (collapsedWidth !== null) card.style.setProperty("--collapsed-width", `${collapsedWidth}px`);
        });
    }
    bindEvents() {
        this.cards.forEach((card)=>{
            card.querySelector(".expanding-card__inner")?.addEventListener("click", (e)=>{
                e.stopPropagation();
                const target = e.target;
                // Only close card when toggle is clicked—opening can happen on a click anywhere
                if (!card.isExpanded || !target?.closest(".expanding-card__content")) this.toggleCard(card);
            });
        });
        // Bind arrow navigation events
        if (this.prevArrow) this.prevArrow.addEventListener("click", ()=>this.navigateToNextCard(-1));
        if (this.nextArrow) this.nextArrow.addEventListener("click", ()=>this.navigateToNextCard(1));
    }
    initializeCardStates() {
        this.cards.forEach((card)=>{
            card.isExpanded = false;
            const toggle = card.querySelector(".expanding-card__toggle");
            if (toggle) {
                const toggleLines = toggle.querySelectorAll(".expanding-card__toggle-line");
                if (toggleLines.length >= 2) {
                    // Set initial state of toggle lines explicitly
                    Motion.animate(toggleLines[0], {
                        rotate: 0
                    }, {
                        duration: 0
                    }).finished;
                    Motion.animate(toggleLines[1], {
                        rotate: 90
                    }, {
                        duration: 0
                    }).finished;
                }
            }
        });
    }
    /**
   * Navigate to the previous card in the carousel
   */ navigateToNextCard(direction) {
        if (!this.cards.length) return;
        const expandedCardIndex = this.findExpandedCardIndex();
        if (expandedCardIndex === -1) // No card is currently expanded, open the first card
        this.toggleCard(this.cards[0]);
        else {
            // Calculate the previous card index with looping
            const index = (expandedCardIndex + direction + this.cards.length) % this.cards.length;
            this.navigateToCard(this.cards[index]);
        }
    }
    /**
   * Navigate directly to a specific card, handling the transition properly
   * even during rapid navigation
   */ navigateToCard(targetCard) {
        // If the target card is already expanded, do nothing
        if (targetCard.isExpanded) return;
        // Force collapse any expanded cards without waiting for animations
        const expandedCards = Array.from(this.cards).filter((c)=>c.isExpanded && c !== targetCard);
        // Collapse all expanded cards without waiting
        expandedCards.forEach((card)=>{
            // Stop any existing animations
            if (card.animation) card.animation.stop();
            this.collapseCard(card);
        });
        // Always scroll to the target card (even on mobile)
        const isMobileSetting = this.isMobile;
        this.isMobile = false;
        this.expandCard(targetCard);
        this.isMobile = isMobileSetting;
    }
    /**
   * Find the index of the currently expanded card
   * @returns The index of the expanded card, or -1 if no card is expanded
   */ findExpandedCardIndex() {
        const index = Array.from(this.cards).findIndex((card)=>card.isExpanded);
        this.log("Expanded card index", index);
        return index;
    }
    getCardScrollPosition(card) {
        const carouselRect = this.carousel.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        // Get computed scroll padding
        const scrollPadding = parseInt(getComputedStyle(this.carousel).scrollPaddingLeft);
        const scrollLeft = this.carousel.scrollLeft;
        // Calculate the card's position relative to the carousel
        const cardOffset = cardRect.left - carouselRect.left + scrollLeft - scrollPadding;
        // If the card is expanded, we need to account for its expanded width
        // when calculating where to scroll
        if (card.isExpanded) return cardOffset;
        // For non-expanded cards, align them with the left edge
        return cardOffset;
    }
    async scrollToCard(card) {
        this.log("Scrolling to card", card);
        // Disable scroll snap during programmatic scrolling
        this.carousel.style.scrollSnapType = "none";
        const startingScroll = this.carousel.scrollLeft;
        const targetScroll = card.scrollPosition ?? 0;
        const scrollDelta = targetScroll - startingScroll;
        // Use native smooth scrolling instead of Motion
        const scrollTo = (0, _remeda.funnel)((dt)=>{
            const currentScroll = this.carousel.scrollLeft;
            const newScroll = startingScroll + scrollDelta * dt;
            if (Math.abs(newScroll - currentScroll) > 5) this.carousel.scrollLeft = newScroll;
        }, {
            minGapMs: 5,
            triggerAt: "both",
            reducer: (_acc, dt)=>dt
        });
        // Animate the proxy value and update scroll position on each frame
        const duration = (0, _remeda.clamp)(0.75 * scrollDelta / 1000, {
            min: 0.25,
            max: 0.75
        });
        this.log({
            scrollDelta,
            duration
        });
        // Wait for the scroll animation to complete
        await Motion.animate(scrollTo.call, {
            easing: "ease-in-out",
            duration
        }).finished;
        // Re-enable scroll snap after scrolling is complete
        this.carousel.style.scrollSnapType = "x mandatory";
    }
    async toggleCard(card) {
        // If the card is already expanded, collapse it
        if (card.isExpanded) {
            await this.collapseCard(card);
            return;
        }
        // Collapse other cards first
        const expandedCards = Array.from(this.cards).filter((c)=>c.isExpanded);
        expandedCards.forEach((c)=>this.collapseCard(c));
        // Then expand the clicked card
        this.expandCard(card);
    }
    expandCard(card) {
        if (card.isExpanded) return;
        const content = card.querySelector(".expanding-card__content");
        const description = card.querySelector(".expanding-card__description");
        const title = card.querySelector(".expanding-card__title");
        const toggle = card.querySelector(".expanding-card__toggle");
        const toggleLines = toggle.querySelectorAll(".expanding-card__toggle-line");
        // Stop any existing animations
        if (card.animation) card.animation.stop();
        if (!this.isMobile) this.scrollToCard(card);
        // Add expanded class for CSS transitions
        card.classList.add("is-expanded");
        card.isExpanded = true;
        const titleHeight = title.clientHeight;
        const padding = 64;
        description.style.height = "auto";
        description.style.opacity = "0";
        // Start animations
        content.animation = Motion.animate(content, {
            height: [
                `${titleHeight + padding}px`,
                `${titleHeight + description.clientHeight + padding}px`
            ]
        }, {
            easing: "ease-in-out",
            duration: 0.25
        });
        description.animation = Motion.animate(description, {
            opacity: 1
        }, {
            easing: "ease-in-out",
            duration: 0.5
        });
        Motion.animate(toggleLines[0], {
            rotate: 45,
            y: "-50%",
            x: "-50%"
        }, {
            easing: Motion.spring(SPRING_CONFIG)
        });
        Motion.animate(toggleLines[1], {
            rotate: -45,
            y: "-50%",
            x: "-50%"
        }, {
            easing: Motion.spring(SPRING_CONFIG)
        });
    }
    async collapseCard(card) {
        const content = card.querySelector(".expanding-card__content");
        const description = card.querySelector(".expanding-card__description");
        const toggle = card.querySelector(".expanding-card__toggle");
        const toggleLines = toggle.querySelectorAll(".expanding-card__toggle-line");
        // Stop any existing animations
        card.animation?.stop();
        content.animation?.stop();
        description.animation?.stop();
        description.style.height = "0px";
        description.style.opacity = "0";
        content.style.height = `auto`;
        // Create animations for toggle lines with explicit end states
        const toggleAnimations = [
            Motion.animate(toggleLines[0], {
                rotate: 0,
                y: "-50%",
                x: "-50%"
            }, {
                easing: Motion.spring(SPRING_CONFIG),
                duration: 0.3
            }),
            Motion.animate(toggleLines[1], {
                rotate: 90,
                y: "-50%",
                x: "-50%"
            }, {
                easing: Motion.spring(SPRING_CONFIG),
                duration: 0.3
            })
        ];
        // Remove expanded class and reset width
        card.classList.remove("is-expanded");
        // Wait for toggle animations to complete
        // await Promise.all(toggleAnimations.map((anim) => anim.finished));
        toggleAnimations.map((anim)=>anim.finished);
        card.isExpanded = false;
    }
}
const expandingCards = new ExpandingCards();

},{"../globals/module-class":"2nrKQ","remeda":"HSD4V","../utils/card-expansion-calculator":"g3inc","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"HSD4V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>(0, _chunkWPTI67A4Js.a));
parcelHelpers.export(exports, "addProp", ()=>(0, _chunkW2ARC73PJs.a));
parcelHelpers.export(exports, "allPass", ()=>(0, _chunk3UBK2BVMJs.a));
parcelHelpers.export(exports, "anyPass", ()=>(0, _chunkVFECZ57DJs.a));
parcelHelpers.export(exports, "capitalize", ()=>(0, _chunkVG2NVNXTJs.a));
parcelHelpers.export(exports, "ceil", ()=>(0, _chunkBXEO7YHQJs.a));
parcelHelpers.export(exports, "chunk", ()=>(0, _chunkWFMWIRTSJs.a));
parcelHelpers.export(exports, "clamp", ()=>(0, _chunkUHDYHGOFJs.a));
parcelHelpers.export(exports, "clone", ()=>(0, _chunk2OQBQB3VJs.a));
parcelHelpers.export(exports, "concat", ()=>(0, _chunkH4OTHZJBJs.a));
parcelHelpers.export(exports, "conditional", ()=>(0, _chunkXZ6COQKMJs.a));
parcelHelpers.export(exports, "constant", ()=>(0, _chunkT5XG33UIJs.a));
parcelHelpers.export(exports, "countBy", ()=>(0, _chunkSBKJLULJJs.a));
parcelHelpers.export(exports, "debounce", ()=>(0, _chunkOIQJEOF7Js.a));
parcelHelpers.export(exports, "difference", ()=>(0, _chunkHVLRA6ZUJs.a));
parcelHelpers.export(exports, "differenceWith", ()=>(0, _chunkC4LV5VIXJs.a));
parcelHelpers.export(exports, "divide", ()=>(0, _chunk2KIKGHAOJs.a));
parcelHelpers.export(exports, "doNothing", ()=>(0, _chunkYVMG2XEUJs.a));
parcelHelpers.export(exports, "drop", ()=>(0, _chunkZP6YI2JTJs.a));
parcelHelpers.export(exports, "dropFirstBy", ()=>(0, _chunkOCJMJQKOJs.a));
parcelHelpers.export(exports, "dropLast", ()=>(0, _chunkJ7R2OSHSJs.a));
parcelHelpers.export(exports, "dropLastWhile", ()=>(0, _chunkGIKF2ZNGJs.a));
parcelHelpers.export(exports, "dropWhile", ()=>(0, _chunkXWBKJZIPJs.a));
parcelHelpers.export(exports, "endsWith", ()=>(0, _chunkXHPQVWZMJs.a));
parcelHelpers.export(exports, "entries", ()=>(0, _chunkVVM5DH6ZJs.a));
parcelHelpers.export(exports, "evolve", ()=>(0, _chunkPVYOMZ3IJs.a));
parcelHelpers.export(exports, "filter", ()=>(0, _chunkP6LAFGANJs.a));
parcelHelpers.export(exports, "find", ()=>(0, _chunkMQDP6CFSJs.a));
parcelHelpers.export(exports, "findIndex", ()=>(0, _chunkUZ6BOIAHJs.a));
parcelHelpers.export(exports, "findLast", ()=>(0, _chunkKI5UAETWJs.a));
parcelHelpers.export(exports, "findLastIndex", ()=>(0, _chunkGYH2VCL4Js.a));
parcelHelpers.export(exports, "first", ()=>(0, _chunk26ILFTOPJs.a));
parcelHelpers.export(exports, "firstBy", ()=>(0, _chunkDAE7EJQ2Js.a));
parcelHelpers.export(exports, "flat", ()=>(0, _chunkXPCYQPKHJs.a));
parcelHelpers.export(exports, "flatMap", ()=>(0, _chunkFRNNS7AXJs.a));
parcelHelpers.export(exports, "floor", ()=>(0, _chunk3XGGB2R4Js.a));
parcelHelpers.export(exports, "forEach", ()=>(0, _chunkVIBSXWWUJs.a));
parcelHelpers.export(exports, "forEachObj", ()=>(0, _chunkT4H4IOYCJs.a));
parcelHelpers.export(exports, "fromEntries", ()=>(0, _chunkGPLTWAVRJs.a));
parcelHelpers.export(exports, "fromKeys", ()=>(0, _chunkPIX5OHMWJs.a));
parcelHelpers.export(exports, "funnel", ()=>(0, _chunkETADWPSKJs.a));
parcelHelpers.export(exports, "groupBy", ()=>(0, _chunkWOUS55DTJs.a));
parcelHelpers.export(exports, "hasAtLeast", ()=>(0, _chunkOAMXQXGRJs.a));
parcelHelpers.export(exports, "hasSubObject", ()=>(0, _chunkR7PILVSQJs.a));
parcelHelpers.export(exports, "identity", ()=>(0, _chunkHJSE3ESOJs.a));
parcelHelpers.export(exports, "indexBy", ()=>(0, _chunkB6PG574OJs.a));
parcelHelpers.export(exports, "intersection", ()=>(0, _chunk32MVV6O6Js.a));
parcelHelpers.export(exports, "intersectionWith", ()=>(0, _chunkYVJOC2U3Js.a));
parcelHelpers.export(exports, "invert", ()=>(0, _chunkOP5ZF26DJs.a));
parcelHelpers.export(exports, "isArray", ()=>(0, _chunkBO3LQZNFJs.a));
parcelHelpers.export(exports, "isBigInt", ()=>(0, _chunkI3D2BSWJJs.a));
parcelHelpers.export(exports, "isBoolean", ()=>(0, _chunk7QX4DO53Js.a));
parcelHelpers.export(exports, "isDate", ()=>(0, _chunkVMV5GVZ5Js.a));
parcelHelpers.export(exports, "isDeepEqual", ()=>(0, _chunkHGKLN5KYJs.a));
parcelHelpers.export(exports, "isDefined", ()=>(0, _chunkOWH4IQQWJs.a));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _chunkVCYTMP4DJs.a));
parcelHelpers.export(exports, "isError", ()=>(0, _chunkCAZXBO45Js.a));
parcelHelpers.export(exports, "isFunction", ()=>(0, _chunkENOHV5LTJs.a));
parcelHelpers.export(exports, "isIncludedIn", ()=>(0, _chunkU753ZCO5Js.a));
parcelHelpers.export(exports, "isNonNull", ()=>(0, _chunk5DU4ITSFJs.a));
parcelHelpers.export(exports, "isNonNullish", ()=>(0, _chunkGK5I7C4JJs.a));
parcelHelpers.export(exports, "isNot", ()=>(0, _chunkHV3WACXGJs.a));
parcelHelpers.export(exports, "isNullish", ()=>(0, _chunkJK3VNB42Js.a));
parcelHelpers.export(exports, "isNumber", ()=>(0, _chunk6GTAPB47Js.a));
parcelHelpers.export(exports, "isObjectType", ()=>(0, _chunkNMC53JVBJs.a));
parcelHelpers.export(exports, "isPlainObject", ()=>(0, _chunkBZNENX2TJs.a));
parcelHelpers.export(exports, "isPromise", ()=>(0, _chunkPULGOXDAJs.a));
parcelHelpers.export(exports, "isShallowEqual", ()=>(0, _chunkOLNQBNAJJs.a));
parcelHelpers.export(exports, "isStrictEqual", ()=>(0, _chunkQOEIYQAGJs.a));
parcelHelpers.export(exports, "isString", ()=>(0, _chunkSFZGYJFIJs.a));
parcelHelpers.export(exports, "isSymbol", ()=>(0, _chunkJJZ7E4YGJs.a));
parcelHelpers.export(exports, "isTruthy", ()=>(0, _chunkXMLUDZIWJs.a));
parcelHelpers.export(exports, "join", ()=>(0, _chunkGMMLSO2NJs.a));
parcelHelpers.export(exports, "keys", ()=>(0, _chunk5NQBDF4HJs.a));
parcelHelpers.export(exports, "last", ()=>(0, _chunkPFSVCZNEJs.a));
parcelHelpers.export(exports, "length", ()=>(0, _chunkVO5MRBXAJs.a));
parcelHelpers.export(exports, "map", ()=>(0, _chunkXUX3ZEXIJs.a));
parcelHelpers.export(exports, "mapKeys", ()=>(0, _chunkKZIKCQ56Js.a));
parcelHelpers.export(exports, "mapToObj", ()=>(0, _chunkP3DXEVTHJs.a));
parcelHelpers.export(exports, "mapValues", ()=>(0, _chunk3ZJAREUDJs.a));
parcelHelpers.export(exports, "mapWithFeedback", ()=>(0, _chunk3T4TGMU4Js.a));
parcelHelpers.export(exports, "mean", ()=>(0, _chunkKQRZQWDEJs.a));
parcelHelpers.export(exports, "meanBy", ()=>(0, _chunk3D3RWAVJJs.a));
parcelHelpers.export(exports, "median", ()=>(0, _chunkK2FFNW24Js.a));
parcelHelpers.export(exports, "merge", ()=>(0, _chunk5S4PYKVYJs.a));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _chunk5WKPQX7LJs.a));
parcelHelpers.export(exports, "mergeDeep", ()=>(0, _chunkPDQFB3TVJs.a));
parcelHelpers.export(exports, "multiply", ()=>(0, _chunkW6ZHPGFPJs.a));
parcelHelpers.export(exports, "nthBy", ()=>(0, _chunkJ3IRE4DIJs.a));
parcelHelpers.export(exports, "objOf", ()=>(0, _chunkRZUYD7QYJs.a));
parcelHelpers.export(exports, "omit", ()=>(0, _chunkA3PVMI4KJs.a));
parcelHelpers.export(exports, "omitBy", ()=>(0, _chunk4ZFFLFWVJs.a));
parcelHelpers.export(exports, "once", ()=>(0, _chunkC6IMN7SFJs.a));
parcelHelpers.export(exports, "only", ()=>(0, _chunkNS6ZBRLPJs.a));
parcelHelpers.export(exports, "partialBind", ()=>(0, _chunkFMPZ2CLXJs.a));
parcelHelpers.export(exports, "partialLastBind", ()=>(0, _chunkR72GEKLPJs.a));
parcelHelpers.export(exports, "partition", ()=>(0, _chunk3IFJP4R5Js.a));
parcelHelpers.export(exports, "pathOr", ()=>(0, _chunkJ4EKWFDWJs.a));
parcelHelpers.export(exports, "pick", ()=>(0, _chunkPGMPBC5QJs.a));
parcelHelpers.export(exports, "pickBy", ()=>(0, _chunkGGYFZTDWJs.a));
parcelHelpers.export(exports, "pipe", ()=>(0, _chunkA3ZTVFWPJs.a));
parcelHelpers.export(exports, "piped", ()=>(0, _chunkQDOP3ITNJs.a));
parcelHelpers.export(exports, "product", ()=>(0, _chunk4NRWDO7PJs.a));
parcelHelpers.export(exports, "prop", ()=>(0, _chunkG5B2IDWBJs.a));
parcelHelpers.export(exports, "pullObject", ()=>(0, _chunk3FKP6OOUJs.a));
parcelHelpers.export(exports, "purry", ()=>(0, _chunkWIMGWYZLJs.a));
parcelHelpers.export(exports, "randomBigInt", ()=>(0, _chunkVFSOOVKJJs.a));
parcelHelpers.export(exports, "randomInteger", ()=>(0, _chunkK3UJMX27Js.a));
parcelHelpers.export(exports, "randomString", ()=>(0, _chunkLE6I3KC6Js.a));
parcelHelpers.export(exports, "range", ()=>(0, _chunkENS7GPLZJs.a));
parcelHelpers.export(exports, "rankBy", ()=>(0, _chunkDSLWSGIDJs.a));
parcelHelpers.export(exports, "reduce", ()=>(0, _chunkC4OZY4Z2Js.a));
parcelHelpers.export(exports, "reverse", ()=>(0, _chunkP2PQB7KOJs.a));
parcelHelpers.export(exports, "round", ()=>(0, _chunkG2JPX77YJs.a));
parcelHelpers.export(exports, "sample", ()=>(0, _chunk6RL33UFTJs.a));
parcelHelpers.export(exports, "set", ()=>(0, _chunkYNNF733LJs.a));
parcelHelpers.export(exports, "setPath", ()=>(0, _chunk4YLWJIJ6Js.a));
parcelHelpers.export(exports, "shuffle", ()=>(0, _chunkKVHF7QRDJs.a));
parcelHelpers.export(exports, "sliceString", ()=>(0, _chunkUA6DVSZ3Js.a));
parcelHelpers.export(exports, "sort", ()=>(0, _chunkNFFV4IQTJs.a));
parcelHelpers.export(exports, "sortBy", ()=>(0, _chunkFDH4IRIMJs.a));
parcelHelpers.export(exports, "sortedIndex", ()=>(0, _chunkYDIA5YQIJs.a));
parcelHelpers.export(exports, "sortedIndexBy", ()=>(0, _chunk6OEKBHIXJs.a));
parcelHelpers.export(exports, "sortedIndexWith", ()=>(0, _chunkGDGEDZJGJs.a));
parcelHelpers.export(exports, "sortedLastIndex", ()=>(0, _chunkXE3XIKTJJs.a));
parcelHelpers.export(exports, "sortedLastIndexBy", ()=>(0, _chunkHVJXDSOPJs.a));
parcelHelpers.export(exports, "splice", ()=>(0, _chunkMSOX5OUIJs.a));
parcelHelpers.export(exports, "split", ()=>(0, _chunkRBODUO3QJs.a));
parcelHelpers.export(exports, "splitAt", ()=>(0, _chunkS52RID4AJs.a));
parcelHelpers.export(exports, "splitWhen", ()=>(0, _chunkWWPMIW33Js.a));
parcelHelpers.export(exports, "startsWith", ()=>(0, _chunk57KROWWSJs.a));
parcelHelpers.export(exports, "stringToPath", ()=>(0, _chunkV6HCOU6TJs.a));
parcelHelpers.export(exports, "subtract", ()=>(0, _chunkALS6JP7SJs.a));
parcelHelpers.export(exports, "sum", ()=>(0, _chunk567G5ZXLJs.a));
parcelHelpers.export(exports, "sumBy", ()=>(0, _chunkQTQTP2VBJs.a));
parcelHelpers.export(exports, "swapIndices", ()=>(0, _chunkDM52TTEPJs.a));
parcelHelpers.export(exports, "swapProps", ()=>(0, _chunk2P44HXVHJs.a));
parcelHelpers.export(exports, "take", ()=>(0, _chunkZJS5DNQWJs.a));
parcelHelpers.export(exports, "takeFirstBy", ()=>(0, _chunkAHDTEY6LJs.a));
parcelHelpers.export(exports, "takeLast", ()=>(0, _chunk4UEQNEAOJs.a));
parcelHelpers.export(exports, "takeLastWhile", ()=>(0, _chunkT4PLMLCPJs.a));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _chunkSSDL7ATGJs.a));
parcelHelpers.export(exports, "tap", ()=>(0, _chunkEVIH3PFYJs.a));
parcelHelpers.export(exports, "times", ()=>(0, _chunkMYLLMFC7Js.a));
parcelHelpers.export(exports, "toCamelCase", ()=>(0, _chunkN4JUOEMSJs.a));
parcelHelpers.export(exports, "toKebabCase", ()=>(0, _chunkYRJ25UV2Js.a));
parcelHelpers.export(exports, "toLowerCase", ()=>(0, _chunkQ5ASJ5N7Js.a));
parcelHelpers.export(exports, "toSnakeCase", ()=>(0, _chunkWZOX4VKUJs.a));
parcelHelpers.export(exports, "toUpperCase", ()=>(0, _chunkY3VKZ3P5Js.a));
parcelHelpers.export(exports, "uncapitalize", ()=>(0, _chunkZRKG4NSCJs.a));
parcelHelpers.export(exports, "unique", ()=>(0, _chunkADT4LUUNJs.a));
parcelHelpers.export(exports, "uniqueBy", ()=>(0, _chunkIXASGXCRJs.a));
parcelHelpers.export(exports, "uniqueWith", ()=>(0, _chunkLDNOJYCIJs.a));
parcelHelpers.export(exports, "values", ()=>(0, _chunkBSLJB6JEJs.a));
parcelHelpers.export(exports, "when", ()=>(0, _chunkNJXNQM3GJs.a));
parcelHelpers.export(exports, "zip", ()=>(0, _chunk6RKHJ2CPJs.a));
parcelHelpers.export(exports, "zipWith", ()=>(0, _chunkQDGUNRDAJs.a));
var _chunkIXASGXCRJs = require("./chunk-IXASGXCR.js");
var _chunkLDNOJYCIJs = require("./chunk-LDNOJYCI.js");
var _chunkBSLJB6JEJs = require("./chunk-BSLJB6JE.js");
var _chunkNJXNQM3GJs = require("./chunk-NJXNQM3G.js");
var _chunk6RKHJ2CPJs = require("./chunk-6RKHJ2CP.js");
var _chunkQDGUNRDAJs = require("./chunk-QDGUNRDA.js");
var _chunkMYLLMFC7Js = require("./chunk-MYLLMFC7.js");
var _chunkN4JUOEMSJs = require("./chunk-N4JUOEMS.js");
var _chunkYRJ25UV2Js = require("./chunk-YRJ25UV2.js");
var _chunkQ5ASJ5N7Js = require("./chunk-Q5ASJ5N7.js");
var _chunkWZOX4VKUJs = require("./chunk-WZOX4VKU.js");
var _chunkDEVKGLTNJs = require("./chunk-DEVKGLTN.js");
var _chunkY3VKZ3P5Js = require("./chunk-Y3VKZ3P5.js");
var _chunkZRKG4NSCJs = require("./chunk-ZRKG4NSC.js");
var _chunkADT4LUUNJs = require("./chunk-ADT4LUUN.js");
var _chunkDM52TTEPJs = require("./chunk-DM52TTEP.js");
var _chunk2P44HXVHJs = require("./chunk-2P44HXVH.js");
var _chunkZJS5DNQWJs = require("./chunk-ZJS5DNQW.js");
var _chunkAHDTEY6LJs = require("./chunk-AHDTEY6L.js");
var _chunk4UEQNEAOJs = require("./chunk-4UEQNEAO.js");
var _chunkT4PLMLCPJs = require("./chunk-T4PLMLCP.js");
var _chunkSSDL7ATGJs = require("./chunk-SSDL7ATG.js");
var _chunkEVIH3PFYJs = require("./chunk-EVIH3PFY.js");
var _chunkRBODUO3QJs = require("./chunk-RBODUO3Q.js");
var _chunkS52RID4AJs = require("./chunk-S52RID4A.js");
var _chunkWWPMIW33Js = require("./chunk-WWPMIW33.js");
var _chunk57KROWWSJs = require("./chunk-57KROWWS.js");
var _chunkV6HCOU6TJs = require("./chunk-V6HCOU6T.js");
var _chunkALS6JP7SJs = require("./chunk-ALS6JP7S.js");
var _chunkQTQTP2VBJs = require("./chunk-QTQTP2VB.js");
var _chunkNFFV4IQTJs = require("./chunk-NFFV4IQT.js");
var _chunkFDH4IRIMJs = require("./chunk-FDH4IRIM.js");
var _chunkYDIA5YQIJs = require("./chunk-YDIA5YQI.js");
var _chunk6OEKBHIXJs = require("./chunk-6OEKBHIX.js");
var _chunkGDGEDZJGJs = require("./chunk-GDGEDZJG.js");
var _chunkXE3XIKTJJs = require("./chunk-XE3XIKTJ.js");
var _chunkHVJXDSOPJs = require("./chunk-HVJXDSOP.js");
var _chunkQEKOZYJ5Js = require("./chunk-QEKOZYJ5.js");
var _chunkMSOX5OUIJs = require("./chunk-MSOX5OUI.js");
var _chunkC4OZY4Z2Js = require("./chunk-C4OZY4Z2.js");
var _chunkP2PQB7KOJs = require("./chunk-P2PQB7KO.js");
var _chunkG2JPX77YJs = require("./chunk-G2JPX77Y.js");
var _chunk6RL33UFTJs = require("./chunk-6RL33UFT.js");
var _chunkYNNF733LJs = require("./chunk-YNNF733L.js");
var _chunk4YLWJIJ6Js = require("./chunk-4YLWJIJ6.js");
var _chunkKVHF7QRDJs = require("./chunk-KVHF7QRD.js");
var _chunkUA6DVSZ3Js = require("./chunk-UA6DVSZ3.js");
var _chunkG5B2IDWBJs = require("./chunk-G5B2IDWB.js");
var _chunk3FKP6OOUJs = require("./chunk-3FKP6OOU.js");
var _chunkVFSOOVKJJs = require("./chunk-VFSOOVKJ.js");
var _chunkK3UJMX27Js = require("./chunk-K3UJMX27.js");
var _chunkLE6I3KC6Js = require("./chunk-LE6I3KC6.js");
var _chunkENS7GPLZJs = require("./chunk-ENS7GPLZ.js");
var _chunkDSLWSGIDJs = require("./chunk-DSLWSGID.js");
var _chunkR72GEKLPJs = require("./chunk-R72GEKLP.js");
var _chunk3IFJP4R5Js = require("./chunk-3IFJP4R5.js");
var _chunkJ4EKWFDWJs = require("./chunk-J4EKWFDW.js");
var _chunkPGMPBC5QJs = require("./chunk-PGMPBC5Q.js");
var _chunkGGYFZTDWJs = require("./chunk-GGYFZTDW.js");
var _chunkQDOP3ITNJs = require("./chunk-QDOP3ITN.js");
var _chunk4NRWDO7PJs = require("./chunk-4NRWDO7P.js");
var _chunkW6ZHPGFPJs = require("./chunk-W6ZHPGFP.js");
var _chunkJ3IRE4DIJs = require("./chunk-J3IRE4DI.js");
var _chunkRZUYD7QYJs = require("./chunk-RZUYD7QY.js");
var _chunkA3PVMI4KJs = require("./chunk-A3PVMI4K.js");
var _chunk4ZFFLFWVJs = require("./chunk-4ZFFLFWV.js");
var _chunkC6IMN7SFJs = require("./chunk-C6IMN7SF.js");
var _chunkNS6ZBRLPJs = require("./chunk-NS6ZBRLP.js");
var _chunkFMPZ2CLXJs = require("./chunk-FMPZ2CLX.js");
var _chunk3ZJAREUDJs = require("./chunk-3ZJAREUD.js");
var _chunk3T4TGMU4Js = require("./chunk-3T4TGMU4.js");
var _chunkKQRZQWDEJs = require("./chunk-KQRZQWDE.js");
var _chunk567G5ZXLJs = require("./chunk-567G5ZXL.js");
var _chunk3D3RWAVJJs = require("./chunk-3D3RWAVJ.js");
var _chunkK2FFNW24Js = require("./chunk-K2FFNW24.js");
var _chunk5S4PYKVYJs = require("./chunk-5S4PYKVY.js");
var _chunk5WKPQX7LJs = require("./chunk-5WKPQX7L.js");
var _chunkPDQFB3TVJs = require("./chunk-PDQFB3TV.js");
var _chunkXMLUDZIWJs = require("./chunk-XMLUDZIW.js");
var _chunkGMMLSO2NJs = require("./chunk-GMMLSO2N.js");
var _chunk5NQBDF4HJs = require("./chunk-5NQBDF4H.js");
var _chunkPFSVCZNEJs = require("./chunk-PFSVCZNE.js");
var _chunkVO5MRBXAJs = require("./chunk-VO5MRBXA.js");
var _chunkXUX3ZEXIJs = require("./chunk-XUX3ZEXI.js");
var _chunkKZIKCQ56Js = require("./chunk-KZIKCQ56.js");
var _chunkP3DXEVTHJs = require("./chunk-P3DXEVTH.js");
var _chunk6GTAPB47Js = require("./chunk-6GTAPB47.js");
var _chunkNMC53JVBJs = require("./chunk-NMC53JVB.js");
var _chunkBZNENX2TJs = require("./chunk-BZNENX2T.js");
var _chunkPULGOXDAJs = require("./chunk-PULGOXDA.js");
var _chunkOLNQBNAJJs = require("./chunk-OLNQBNAJ.js");
var _chunkQOEIYQAGJs = require("./chunk-QOEIYQAG.js");
var _chunkSFZGYJFIJs = require("./chunk-SFZGYJFI.js");
var _chunkJJZ7E4YGJs = require("./chunk-JJZ7E4YG.js");
var _chunkVCYTMP4DJs = require("./chunk-VCYTMP4D.js");
var _chunkCAZXBO45Js = require("./chunk-CAZXBO45.js");
var _chunkENOHV5LTJs = require("./chunk-ENOHV5LT.js");
var _chunkU753ZCO5Js = require("./chunk-U753ZCO5.js");
var _chunk5DU4ITSFJs = require("./chunk-5DU4ITSF.js");
var _chunkGK5I7C4JJs = require("./chunk-GK5I7C4J.js");
var _chunkHV3WACXGJs = require("./chunk-HV3WACXG.js");
var _chunkJK3VNB42Js = require("./chunk-JK3VNB42.js");
var _chunkYVJOC2U3Js = require("./chunk-YVJOC2U3.js");
var _chunkOP5ZF26DJs = require("./chunk-OP5ZF26D.js");
var _chunkBO3LQZNFJs = require("./chunk-BO3LQZNF.js");
var _chunkI3D2BSWJJs = require("./chunk-I3D2BSWJ.js");
var _chunk7QX4DO53Js = require("./chunk-7QX4DO53.js");
var _chunkVMV5GVZ5Js = require("./chunk-VMV5GVZ5.js");
var _chunkOWH4IQQWJs = require("./chunk-OWH4IQQW.js");
var _chunkETADWPSKJs = require("./chunk-ETADWPSK.js");
var _chunkWOUS55DTJs = require("./chunk-WOUS55DT.js");
var _chunkR7PILVSQJs = require("./chunk-R7PILVSQ.js");
var _chunkHGKLN5KYJs = require("./chunk-HGKLN5KY.js");
var _chunkHJSE3ESOJs = require("./chunk-HJSE3ESO.js");
var _chunkB6PG574OJs = require("./chunk-B6PG574O.js");
var _chunk32MVV6O6Js = require("./chunk-32MVV6O6.js");
var _chunkDAE7EJQ2Js = require("./chunk-DAE7EJQ2.js");
var _chunkXPCYQPKHJs = require("./chunk-XPCYQPKH.js");
var _chunkFRNNS7AXJs = require("./chunk-FRNNS7AX.js");
var _chunk3XGGB2R4Js = require("./chunk-3XGGB2R4.js");
var _chunkVIBSXWWUJs = require("./chunk-VIBSXWWU.js");
var _chunkT4H4IOYCJs = require("./chunk-T4H4IOYC.js");
var _chunkGPLTWAVRJs = require("./chunk-GPLTWAVR.js");
var _chunkPIX5OHMWJs = require("./chunk-PIX5OHMW.js");
var _chunkVVM5DH6ZJs = require("./chunk-VVM5DH6Z.js");
var _chunkPVYOMZ3IJs = require("./chunk-PVYOMZ3I.js");
var _chunkP6LAFGANJs = require("./chunk-P6LAFGAN.js");
var _chunkMQDP6CFSJs = require("./chunk-MQDP6CFS.js");
var _chunkUZ6BOIAHJs = require("./chunk-UZ6BOIAH.js");
var _chunkKI5UAETWJs = require("./chunk-KI5UAETW.js");
var _chunkGYH2VCL4Js = require("./chunk-GYH2VCL4.js");
var _chunk26ILFTOPJs = require("./chunk-26ILFTOP.js");
var _chunkSGAFZVQHJs = require("./chunk-SGAFZVQH.js");
var _chunk2KIKGHAOJs = require("./chunk-2KIKGHAO.js");
var _chunkYVMG2XEUJs = require("./chunk-YVMG2XEU.js");
var _chunkZP6YI2JTJs = require("./chunk-ZP6YI2JT.js");
var _chunkOCJMJQKOJs = require("./chunk-OCJMJQKO.js");
var _chunkP5WDBFN2Js = require("./chunk-P5WDBFN2.js");
var _chunkDH3BPT6TJs = require("./chunk-DH3BPT6T.js");
var _chunkEMIEIAAHJs = require("./chunk-EMIEIAAH.js");
var _chunkOAMXQXGRJs = require("./chunk-OAMXQXGR.js");
var _chunkJ7R2OSHSJs = require("./chunk-J7R2OSHS.js");
var _chunkGIKF2ZNGJs = require("./chunk-GIKF2ZNG.js");
var _chunkXWBKJZIPJs = require("./chunk-XWBKJZIP.js");
var _chunkXHPQVWZMJs = require("./chunk-XHPQVWZM.js");
var _chunk2OQBQB3VJs = require("./chunk-2OQBQB3V.js");
var _chunkH4OTHZJBJs = require("./chunk-H4OTHZJB.js");
var _chunkXZ6COQKMJs = require("./chunk-XZ6COQKM.js");
var _chunkT5XG33UIJs = require("./chunk-T5XG33UI.js");
var _chunkSBKJLULJJs = require("./chunk-SBKJLULJ.js");
var _chunkOIQJEOF7Js = require("./chunk-OIQJEOF7.js");
var _chunkHVLRA6ZUJs = require("./chunk-HVLRA6ZU.js");
var _chunkC4LV5VIXJs = require("./chunk-C4LV5VIX.js");
var _chunkBCPWYWXNJs = require("./chunk-BCPWYWXN.js");
var _chunkA3ZTVFWPJs = require("./chunk-A3ZTVFWP.js");
var _chunkANXBDSUIJs = require("./chunk-ANXBDSUI.js");
var _chunkWPTI67A4Js = require("./chunk-WPTI67A4.js");
var _chunkW2ARC73PJs = require("./chunk-W2ARC73P.js");
var _chunk3UBK2BVMJs = require("./chunk-3UBK2BVM.js");
var _chunkVFECZ57DJs = require("./chunk-VFECZ57D.js");
var _chunkVG2NVNXTJs = require("./chunk-VG2NVNXT.js");
var _chunkBXEO7YHQJs = require("./chunk-BXEO7YHQ.js");
var _chunkSDLIKNSYJs = require("./chunk-SDLIKNSY.js");
var _chunkWFMWIRTSJs = require("./chunk-WFMWIRTS.js");
var _chunkUHDYHGOFJs = require("./chunk-UHDYHGOF.js");
var _chunkWIMGWYZLJs = require("./chunk-WIMGWYZL.js");
var _chunkD6FCK2GAJs = require("./chunk-D6FCK2GA.js");

},{"./chunk-IXASGXCR.js":false,"./chunk-LDNOJYCI.js":false,"./chunk-BSLJB6JE.js":false,"./chunk-NJXNQM3G.js":false,"./chunk-6RKHJ2CP.js":false,"./chunk-QDGUNRDA.js":false,"./chunk-MYLLMFC7.js":false,"./chunk-N4JUOEMS.js":false,"./chunk-YRJ25UV2.js":false,"./chunk-Q5ASJ5N7.js":false,"./chunk-WZOX4VKU.js":false,"./chunk-DEVKGLTN.js":"dQENT","./chunk-Y3VKZ3P5.js":false,"./chunk-ZRKG4NSC.js":false,"./chunk-ADT4LUUN.js":false,"./chunk-DM52TTEP.js":false,"./chunk-2P44HXVH.js":false,"./chunk-ZJS5DNQW.js":false,"./chunk-AHDTEY6L.js":false,"./chunk-4UEQNEAO.js":false,"./chunk-T4PLMLCP.js":false,"./chunk-SSDL7ATG.js":false,"./chunk-EVIH3PFY.js":false,"./chunk-RBODUO3Q.js":false,"./chunk-S52RID4A.js":false,"./chunk-WWPMIW33.js":false,"./chunk-57KROWWS.js":false,"./chunk-V6HCOU6T.js":false,"./chunk-ALS6JP7S.js":false,"./chunk-QTQTP2VB.js":false,"./chunk-NFFV4IQT.js":false,"./chunk-FDH4IRIM.js":false,"./chunk-YDIA5YQI.js":false,"./chunk-6OEKBHIX.js":false,"./chunk-GDGEDZJG.js":false,"./chunk-XE3XIKTJ.js":false,"./chunk-HVJXDSOP.js":false,"./chunk-QEKOZYJ5.js":"5BSlA","./chunk-MSOX5OUI.js":false,"./chunk-C4OZY4Z2.js":false,"./chunk-P2PQB7KO.js":false,"./chunk-G2JPX77Y.js":false,"./chunk-6RL33UFT.js":false,"./chunk-YNNF733L.js":false,"./chunk-4YLWJIJ6.js":false,"./chunk-KVHF7QRD.js":false,"./chunk-UA6DVSZ3.js":false,"./chunk-G5B2IDWB.js":false,"./chunk-3FKP6OOU.js":false,"./chunk-VFSOOVKJ.js":false,"./chunk-K3UJMX27.js":false,"./chunk-LE6I3KC6.js":false,"./chunk-ENS7GPLZ.js":false,"./chunk-DSLWSGID.js":false,"./chunk-R72GEKLP.js":false,"./chunk-3IFJP4R5.js":false,"./chunk-J4EKWFDW.js":false,"./chunk-PGMPBC5Q.js":false,"./chunk-GGYFZTDW.js":false,"./chunk-QDOP3ITN.js":false,"./chunk-4NRWDO7P.js":false,"./chunk-W6ZHPGFP.js":false,"./chunk-J3IRE4DI.js":false,"./chunk-RZUYD7QY.js":false,"./chunk-A3PVMI4K.js":false,"./chunk-4ZFFLFWV.js":false,"./chunk-C6IMN7SF.js":false,"./chunk-NS6ZBRLP.js":false,"./chunk-FMPZ2CLX.js":false,"./chunk-3ZJAREUD.js":false,"./chunk-3T4TGMU4.js":false,"./chunk-KQRZQWDE.js":false,"./chunk-567G5ZXL.js":false,"./chunk-3D3RWAVJ.js":false,"./chunk-K2FFNW24.js":false,"./chunk-5S4PYKVY.js":false,"./chunk-5WKPQX7L.js":false,"./chunk-PDQFB3TV.js":false,"./chunk-XMLUDZIW.js":false,"./chunk-GMMLSO2N.js":false,"./chunk-5NQBDF4H.js":false,"./chunk-PFSVCZNE.js":false,"./chunk-VO5MRBXA.js":false,"./chunk-XUX3ZEXI.js":false,"./chunk-KZIKCQ56.js":false,"./chunk-P3DXEVTH.js":false,"./chunk-6GTAPB47.js":false,"./chunk-NMC53JVB.js":false,"./chunk-BZNENX2T.js":false,"./chunk-PULGOXDA.js":false,"./chunk-OLNQBNAJ.js":false,"./chunk-QOEIYQAG.js":false,"./chunk-SFZGYJFI.js":false,"./chunk-JJZ7E4YG.js":false,"./chunk-VCYTMP4D.js":false,"./chunk-CAZXBO45.js":false,"./chunk-ENOHV5LT.js":false,"./chunk-U753ZCO5.js":false,"./chunk-5DU4ITSF.js":false,"./chunk-GK5I7C4J.js":false,"./chunk-HV3WACXG.js":false,"./chunk-JK3VNB42.js":false,"./chunk-YVJOC2U3.js":false,"./chunk-OP5ZF26D.js":false,"./chunk-BO3LQZNF.js":false,"./chunk-I3D2BSWJ.js":false,"./chunk-7QX4DO53.js":false,"./chunk-VMV5GVZ5.js":false,"./chunk-OWH4IQQW.js":false,"./chunk-ETADWPSK.js":"67DBG","./chunk-WOUS55DT.js":false,"./chunk-R7PILVSQ.js":false,"./chunk-HGKLN5KY.js":false,"./chunk-HJSE3ESO.js":false,"./chunk-B6PG574O.js":false,"./chunk-32MVV6O6.js":false,"./chunk-DAE7EJQ2.js":false,"./chunk-XPCYQPKH.js":false,"./chunk-FRNNS7AX.js":false,"./chunk-3XGGB2R4.js":false,"./chunk-VIBSXWWU.js":false,"./chunk-T4H4IOYC.js":false,"./chunk-GPLTWAVR.js":false,"./chunk-PIX5OHMW.js":false,"./chunk-VVM5DH6Z.js":false,"./chunk-PVYOMZ3I.js":false,"./chunk-P6LAFGAN.js":false,"./chunk-MQDP6CFS.js":false,"./chunk-UZ6BOIAH.js":false,"./chunk-KI5UAETW.js":false,"./chunk-GYH2VCL4.js":false,"./chunk-26ILFTOP.js":false,"./chunk-SGAFZVQH.js":"9Pygc","./chunk-2KIKGHAO.js":false,"./chunk-YVMG2XEU.js":false,"./chunk-ZP6YI2JT.js":false,"./chunk-OCJMJQKO.js":false,"./chunk-P5WDBFN2.js":"bQbrg","./chunk-DH3BPT6T.js":"dRXQn","./chunk-EMIEIAAH.js":"6iULw","./chunk-OAMXQXGR.js":false,"./chunk-J7R2OSHS.js":false,"./chunk-GIKF2ZNG.js":false,"./chunk-XWBKJZIP.js":false,"./chunk-XHPQVWZM.js":false,"./chunk-2OQBQB3V.js":false,"./chunk-H4OTHZJB.js":false,"./chunk-XZ6COQKM.js":false,"./chunk-T5XG33UI.js":false,"./chunk-SBKJLULJ.js":false,"./chunk-OIQJEOF7.js":false,"./chunk-HVLRA6ZU.js":false,"./chunk-C4LV5VIX.js":false,"./chunk-BCPWYWXN.js":"bavBT","./chunk-A3ZTVFWP.js":false,"./chunk-ANXBDSUI.js":"fkSvB","./chunk-WPTI67A4.js":false,"./chunk-W2ARC73P.js":false,"./chunk-3UBK2BVM.js":false,"./chunk-VFECZ57D.js":false,"./chunk-VG2NVNXT.js":false,"./chunk-BXEO7YHQ.js":false,"./chunk-SDLIKNSY.js":"f3deG","./chunk-WFMWIRTS.js":false,"./chunk-UHDYHGOF.js":"jMZEl","./chunk-WIMGWYZL.js":false,"./chunk-D6FCK2GA.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"dQENT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>i);
var o = [
    "	",
    `
`,
    "\v",
    "\f",
    "\r",
    " ",
    "\x85",
    "\xa0",
    "\u1680",
    "\u2000",
    "\u2001",
    "\u2002",
    "\u2003",
    "\u2004",
    "\u2005",
    "\u2006",
    "\u2007",
    "\u2008",
    "\u2009",
    "\u200A",
    "\u2028",
    "\u2029",
    "\u202F",
    "\u205F",
    "\u3000",
    "\uFEFF"
], c = new Set([
    "-",
    "_",
    ...o
]), i = (r)=>{
    let e = [], t = "", u = ()=>{
        t.length > 0 && (e.push(t), t = "");
    };
    for (let s of r){
        if (c.has(s)) {
            u();
            continue;
        }
        if (/[a-z]$/u.test(t) && /[A-Z]/u.test(s)) u();
        else if (/[A-Z][A-Z]$/u.test(t) && /[a-z]/u.test(s)) {
            let n = t.slice(-1);
            t = t.slice(0, -1), u(), t = n;
        } else /\d$/u.test(t) !== /\d/u.test(s) && u();
        t += s;
    }
    return u(), e;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"5BSlA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>i);
function i(o, l) {
    let t = 0, e = o.length;
    for(; t < e;){
        let n = t + e >>> 1, d = o[n];
        l(d, n, o) ? t = n + 1 : e = n;
    }
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"67DBG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>T);
function T(c, { triggerAt: l = "end", minQuietPeriodMs: i, maxBurstDurationMs: t, minGapMs: o, reducer: p = g }) {
    let e, n, d, r, a = ()=>{
        let u = d;
        u !== void 0 && (d = void 0, c(u), o !== void 0 && (n = setTimeout(f, o)));
    }, f = ()=>{
        clearTimeout(n), n = void 0, e === void 0 && a();
    }, m = ()=>{
        clearTimeout(e), e = void 0, r = void 0, n === void 0 && a();
    };
    return {
        call: (...u)=>{
            let s = e === void 0 && n === void 0;
            if ((l !== "start" || s) && (d = p(d, ...u)), !(e === void 0 && !s)) {
                if (i !== void 0 || t !== void 0 || o === void 0) {
                    clearTimeout(e);
                    let y = Date.now();
                    r ??= y;
                    let R = t === void 0 ? i ?? 0 : Math.min(i ?? t, t - (y - r));
                    e = setTimeout(m, R);
                }
                l !== "end" && s && a();
            }
        },
        cancel: ()=>{
            clearTimeout(e), e = void 0, r = void 0, clearTimeout(n), n = void 0, d = void 0;
        },
        flush: ()=>{
            m(), f();
        },
        get isIdle () {
            return e === void 0 && n === void 0;
        }
    };
}
var g = ()=>"";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"9Pygc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>e);
var e = (n)=>Object.assign(n, {
        single: !0
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"bQbrg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>T);
parcelHelpers.export(exports, "b", ()=>m);
var _chunkDH3BPT6TJs = require("./chunk-DH3BPT6T.js");
var _chunkOAMXQXGRJs = require("./chunk-OAMXQXGR.js");
function T(n, o) {
    for(let r = Math.floor(n.length / 2) - 1; r >= 0; r--)c(n, r, o);
}
function m(n, o, r) {
    if (!(0, _chunkOAMXQXGRJs.a)(n, 1)) return;
    let [t] = n;
    if (!(o(r, t) >= 0)) return n[0] = r, c(n, 0, o), t;
}
function c(n, o, r) {
    let t = o;
    for(; t * 2 + 1 < n.length;){
        let i = t * 2 + 1, e = r(n[t], n[i]) < 0 ? i : t, f = i + 1;
        if (f < n.length && r(n[e], n[f]) < 0 && (e = f), e === t) return;
        (0, _chunkDH3BPT6TJs.a)(n, t, e), t = e;
    }
}

},{"./chunk-DH3BPT6T.js":"dRXQn","./chunk-OAMXQXGR.js":"04Bbb","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"dRXQn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>o);
function o(n, r, e) {
    [n[r], n[e]] = [
        n[e],
        n[r]
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"04Bbb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>i);
var _chunkWIMGWYZLJs = require("./chunk-WIMGWYZL.js");
function i(...e) {
    return (0, _chunkWIMGWYZLJs.a)(r, e);
}
var r = (e, t)=>e.length >= t;

},{"./chunk-WIMGWYZL.js":"vj6KB","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"vj6KB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>u);
var _chunkD6FCK2GAJs = require("./chunk-D6FCK2GA.js");
function u(r, n, o) {
    let a = r.length - n.length;
    if (a === 0) return r(...n);
    if (a === 1) return (0, _chunkD6FCK2GAJs.a)(r, n, o);
    throw new Error("Wrong number of arguments");
}

},{"./chunk-D6FCK2GA.js":"l5Sr5","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"l5Sr5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>u);
function u(o, n, a) {
    let t = (r)=>o(r, ...n);
    return a === void 0 ? t : Object.assign(t, {
        lazy: a,
        lazyArgs: n
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"6iULw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>s);
parcelHelpers.export(exports, "b", ()=>f);
var T = {
    asc: (r, n)=>r > n,
    desc: (r, n)=>r < n
};
function s(r, n) {
    let [e, ...o] = n;
    if (!m(e)) {
        let t = u(...o);
        return r(e, t);
    }
    let a = u(e, ...o);
    return (t)=>r(t, a);
}
function f(r, [n, e, ...o]) {
    let a, t;
    return m(e) ? (a = n, t = [
        e,
        ...o
    ]) : (a = e, t = [
        n,
        ...o
    ]), s((...i)=>r(...i, a), t);
}
function u(r, n, ...e) {
    let o = typeof r == "function" ? r : r[0], a = typeof r == "function" ? "asc" : r[1], { [a]: t } = T, i = n === void 0 ? void 0 : u(n, ...e);
    return (y, c)=>{
        let p = o(y), l = o(c);
        return t(p, l) ? 1 : t(l, p) ? -1 : i?.(y, c) ?? 0;
    };
}
function m(r) {
    if (d(r)) return !0;
    if (typeof r != "object" || !Array.isArray(r)) return !1;
    let [n, e, ...o] = r;
    return d(n) && typeof e == "string" && e in T && o.length === 0;
}
var d = (r)=>typeof r == "function" && r.length === 1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"bavBT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>y);
var _chunkA3ZTVFWPJs = require("./chunk-A3ZTVFWP.js");
function y(t, i) {
    let a = i.length - t.length;
    if (a === 1) {
        let [n, ...r] = i;
        return (0, _chunkA3ZTVFWPJs.a)(n, {
            lazy: t,
            lazyArgs: r
        });
    }
    if (a === 0) {
        let n = {
            lazy: t,
            lazyArgs: i
        };
        return Object.assign((e)=>(0, _chunkA3ZTVFWPJs.a)(e, n), n);
    }
    throw new Error("Wrong number of arguments");
}

},{"./chunk-A3ZTVFWP.js":"kbGO2","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"kbGO2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>C);
var _chunkANXBDSUIJs = require("./chunk-ANXBDSUI.js");
function C(t, ...o) {
    let n = t, u = o.map((e)=>"lazy" in e ? A(e) : void 0), p = 0;
    for(; p < o.length;){
        if (u[p] === void 0 || !B(n)) {
            let i = o[p];
            n = i(n), p += 1;
            continue;
        }
        let r = [];
        for(let i = p; i < o.length; i++){
            let l = u[i];
            if (l === void 0 || (r.push(l), l.isSingle)) break;
        }
        let a = [];
        for (let i of n)if (y(i, a, r)) break;
        let { isSingle: s } = r.at(-1);
        n = s ? a[0] : a, p += r.length;
    }
    return n;
}
function y(t, o, n) {
    if (n.length === 0) return o.push(t), !1;
    let u = t, p = (0, _chunkANXBDSUIJs.a), e = !1;
    for (let [r, a] of n.entries()){
        let { index: s, items: i } = a;
        if (i.push(u), p = a(u, s, i), a.index += 1, p.hasNext) {
            if (p.hasMany ?? !1) {
                for (let l of p.next)if (y(l, o, n.slice(r + 1))) return !0;
                return e;
            }
            u = p.next;
        }
        if (!p.hasNext) break;
        p.done && (e = !0);
    }
    return p.hasNext && o.push(u), e;
}
function A(t) {
    let { lazy: o, lazyArgs: n } = t, u = o(...n);
    return Object.assign(u, {
        isSingle: o.single ?? !1,
        index: 0,
        items: []
    });
}
function B(t) {
    return typeof t == "string" || typeof t == "object" && t !== null && Symbol.iterator in t;
}

},{"./chunk-ANXBDSUI.js":"fkSvB","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"fkSvB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>s);
parcelHelpers.export(exports, "b", ()=>a);
parcelHelpers.export(exports, "c", ()=>o);
var e = {
    done: !0,
    hasNext: !1
}, s = {
    done: !1,
    hasNext: !1
}, a = ()=>e, o = (t)=>({
        hasNext: !0,
        next: t,
        done: !1
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"f3deG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>m);
function m(e) {
    return (t, r)=>{
        if (r === 0) return e(t);
        if (!Number.isInteger(r)) throw new TypeError(`precision must be an integer: ${r.toString()}`);
        if (r > 15 || r < -15) throw new RangeError("precision must be between -15 and 15");
        if (Number.isNaN(t) || !Number.isFinite(t)) return e(t);
        if (r > 0) {
            let b = 10 ** r;
            return e(t * b) / b;
        }
        let n = 10 ** -r;
        return e(t / n) * n;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"jMZEl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>u);
var _chunkWIMGWYZLJs = require("./chunk-WIMGWYZL.js");
function u(...n) {
    return (0, _chunkWIMGWYZLJs.a)(i, n);
}
var i = (n, { min: e, max: r })=>e !== void 0 && n < e ? e : r !== void 0 && n > r ? r : n;

},{"./chunk-WIMGWYZL.js":"vj6KB","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"g3inc":[function(require,module,exports) {
/**
 * Types of width calculations
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A lightweight utility to calculate card widths at different breakpoints
 */ parcelHelpers.export(exports, "CardExpansionCalculator", ()=>CardExpansionCalculator);
class CardExpansionCalculator {
    /**
   * Create a new card expansion calculator
   */ constructor(config){
        // Set default configuration
        this.config = {
            gap: config.gap ?? 0,
            defaultExpandedWidth: config.defaultExpandedWidth,
            defaultCollapsedWidth: config.defaultCollapsedWidth ?? null,
            breakpoints: config.breakpoints ?? []
        };
        // Sort breakpoints from largest to smallest for proper matching
        this.config.breakpoints.sort((a, b)=>b.maxWidth - a.maxWidth);
    }
    /**
   * Get the current breakpoint configuration based on window width
   */ getCurrentBreakpoint() {
        const windowWidth = window.innerWidth;
        return this.config.breakpoints.find((bp)=>windowWidth <= bp.maxWidth) || null;
    }
    /**
   * Calculate width based on a width strategy and container width
   */ calculateWidthFromStrategy(strategy, containerWidth, cardCount) {
        switch(strategy.type){
            case "fixed":
                return strategy.value;
            case "percentage":
                const totalGapWidth = (cardCount - 1) * this.config.gap;
                const totalPadding = (cardCount - 1) * (strategy.padding ?? 0);
                const availableWidth = containerWidth - totalGapWidth - totalPadding;
                return Math.floor(availableWidth * strategy.value);
        }
    }
    /**
   * Calculate the expanded width for cards
   * @param containerWidth The width of the container
   * @param cardCount The number of cards
   * @returns The calculated expanded width in pixels
   */ getExpandedWidth(containerWidth, cardCount) {
        const breakpoint = this.getCurrentBreakpoint();
        const widthStrategy = breakpoint?.expandedWidth || this.config.defaultExpandedWidth;
        return this.calculateWidthFromStrategy(widthStrategy, containerWidth, cardCount);
    }
    /**
   * Calculate the collapsed width for cards
   * @param containerWidth The width of the container
   * @param cardCount The number of cards
   * @returns The calculated collapsed width in pixels, or null if not specified
   */ getCollapsedWidth(containerWidth, cardCount) {
        const breakpoint = this.getCurrentBreakpoint();
        const widthStrategy = breakpoint?.collapsedWidth || this.config.defaultCollapsedWidth;
        if (!widthStrategy) return null;
        return this.calculateWidthFromStrategy(widthStrategy, containerWidth, cardCount);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"hZcLp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expandingCardsHover", ()=>expandingCardsHover);
var _carouselManager = require("scripts/utils/CarouselManager");
var _moduleClass = require("../globals/module-class");
var _cardExpansionCalculator = require("../utils/card-expansion-calculator");
const mobileBreakpoint = 1279;
class ExpandingCardsHover extends (0, _moduleClass.FLModule) {
    constructor(container){
        super("ExpandingCardsHover");
        this.id = "";
        this.cards = document.querySelectorAll(".expanding-cards__card");
        this.container = null;
        this.grid = null;
        this.hasHoverSupport = window.matchMedia("(hover: hover)").matches;
        this.isAnimating = false;
        this.animationTimeout = null;
        this.hoverIntentTimeout = null;
        this.hoverIntentDelay = 50 // Small delay to prevent accidental hover triggers
        ;
        this.resizeObserver = null;
        this.expansionCalculator = null;
        this.container = container;
    }
    init() {
        if (!this.container) return;
        this.id = this.container.closest(".shopify-section")?.id ?? "";
        this.cards = this.container.querySelectorAll(".expanding-cards__card");
        if (this.cards.length === 0) return;
        this.grid = this.container.querySelector(".expanding-cards__grid");
        // Initialize the card expansion calculator
        this.initExpansionCalculator();
        this.initCards();
        this.bindEvents();
        this.setupResizeObserver();
        if (this.isMobile) this.initCarousel();
        else this.destroyCarousel();
        // Calculate expanded widths immediately
        this.calculateExpandedWidths();
        // And recalculate after everything is loaded
        window.addEventListener("load", ()=>{
            this.calculateExpandedWidths();
        });
    }
    /**
   * Initialize the card expansion calculator with appropriate breakpoints
   */ initExpansionCalculator() {
        // Define the default expanded width (50% of available space)
        const defaultExpandedWidth = {
            type: "percentage",
            value: 0.5
        };
        // Define the default collapsed width (equal distribution)
        const defaultCollapsedWidth = {
            type: "percentage",
            value: 1 / this.cards.length,
            padding: 64
        };
        // Create the calculator with breakpoints
        this.expansionCalculator = new (0, _cardExpansionCalculator.CardExpansionCalculator)({
            gap: 30,
            defaultExpandedWidth,
            defaultCollapsedWidth
        });
    }
    initCards() {
        // Initialize each card with default state
        this.cards.forEach((card)=>{
            card.isHovered = false;
            card.isActive = false;
        });
    }
    bindEvents() {
        // Add event listeners to cards
        this.cards.forEach((card)=>{
            // Always bind hover events for devices that support it
            card.addEventListener("mouseenter", ()=>{
                if (this.hasHoverSupport) {
                    // Clear any existing hover intent timeout
                    if (this.hoverIntentTimeout) window.clearTimeout(this.hoverIntentTimeout);
                    // Set a small delay to prevent accidental hover triggers
                    this.hoverIntentTimeout = window.setTimeout(()=>{
                        this.handleCardToggle(card, true);
                        this.hoverIntentTimeout = null;
                    }, this.hoverIntentDelay);
                }
            });
            card.addEventListener("mouseleave", ()=>{
                if (this.hasHoverSupport) {
                    // Clear any existing hover intent timeout
                    if (this.hoverIntentTimeout) {
                        window.clearTimeout(this.hoverIntentTimeout);
                        this.hoverIntentTimeout = null;
                    }
                    this.handleCardToggle(card, false);
                }
            });
            // Add click event for all devices (especially important for touch devices)
            card.addEventListener("click", (e)=>{
                if (this.isAnimating) return;
                // If the card is already active and we're clicking a link, allow the click
                if (card.isActive && e.target.closest("a")) return;
                e.preventDefault();
                this.handleCardToggle(card);
            });
            // Handle focus events for accessibility
            card.addEventListener("focus", ()=>{
                this.handleCardToggle(card, true);
            });
            card.addEventListener("blur", ()=>{
                this.handleCardToggle(card, false);
            });
            // Listen for image load events to position content correctly
            const cardImage = card.querySelector(".expanding-cards__card-image img");
            if (cardImage) cardImage.addEventListener("load", ()=>{
                this.positionCardContent(card);
            });
        });
        // Add document click handler to close expanded card when clicking outside
        document.addEventListener("click", (e)=>{
            if (!this.isAnimating && !this.container?.contains(e.target)) this.resetCards();
        });
        // Handle window resize
        window.addEventListener("resize", ()=>{
            this.handleResize(this.isMobile);
            // Recalculate expanded widths after resize
            this.calculateExpandedWidths();
        });
        // Check for hover support on media change
        const mediaQuery = window.matchMedia("(hover: hover)");
        mediaQuery.addEventListener("change", (e)=>{
            this.hasHoverSupport = e.matches;
        });
    }
    /**
   * Setup ResizeObserver to monitor grid size changes
   */ setupResizeObserver() {
        if (!this.grid || typeof ResizeObserver === "undefined") return;
        this.resizeObserver = new ResizeObserver(()=>{
            this.calculateExpandedWidths();
        });
        this.resizeObserver.observe(this.grid);
    }
    /**
   * Calculate the width each card would have when expanded
   */ calculateExpandedWidths() {
        if (!this.grid || !this.cards.length || !this.expansionCalculator) return;
        if (this.isMobile) {
            this.cards.forEach((card)=>{
                card.expandedWidth = card.offsetWidth;
                card.style.setProperty("--expanded-width", `${card.expandedWidth}px`);
            });
            return;
        }
        const gridWidth = this.grid.offsetWidth;
        // Use the calculator to get the expanded and collapsed widths
        const expandedWidth = this.expansionCalculator.getExpandedWidth(gridWidth, this.cards.length);
        const collapsedWidth = this.expansionCalculator.getCollapsedWidth(gridWidth, this.cards.length);
        // Store and apply the widths to each card
        this.cards.forEach((card)=>{
            card.expandedWidth = expandedWidth;
            // Set CSS custom properties for use in styles
            card.style.setProperty("--expanded-width", `${expandedWidth}px`);
            if (collapsedWidth !== null) card.style.setProperty("--collapsed-width", `${collapsedWidth}px`);
            // Position the card content with the new width
            this.positionCardContent(card);
        });
    }
    /**
   * Position the content of a card so that the title is visible with proper padding
   */ positionCardContent(card) {
        this.log("positionCardContent", {
            card
        });
        // We no longer need complex positioning logic
        // Just set the width for the expanded content
        if (card.expandedWidth) {
            const expandedContent = card.querySelector(".expanding-cards__card-expanded-content");
            const expandedTitle = card.querySelector(".expanding-cards__card-title-expanded");
            const description = card.querySelector(".expanding-cards__card-description");
            if (expandedContent) {
                // Account for padding (40px on each side)
                const contentWidth = card.expandedWidth - 80;
                if (expandedTitle) {
                    if (!this.isMobile) expandedTitle.style.width = `${contentWidth}px`;
                    else expandedTitle.style.width = "unset";
                }
                if (description) {
                    if (!this.isMobile) description.style.width = `${contentWidth}px`;
                    else description.style.width = "unset";
                }
            }
        }
    }
    handleCardToggle(card, isActive) {
        this.log("handleCardToggle", {
            card,
            isActive
        });
        if (this.isMobile) return;
        // For touch devices or when explicitly clicking
        this.isAnimating = true;
        // Toggle the active state
        const newActiveState = isActive ?? !card.isActive;
        if (newActiveState) {
            this.resetCards(card);
            this.setCardActive(card, true);
        } else this.setCardActive(card, false);
        // Reset animation lock after animation completes
        if (this.animationTimeout) window.clearTimeout(this.animationTimeout);
        this.animationTimeout = window.setTimeout(()=>{
            this.isAnimating = false;
            this.animationTimeout = null;
        }, 500); // Match the transition duration in CSS
    }
    setCardActive(card, isActive) {
        // Apply a small delay before adding the class to ensure smooth transitions
        if (isActive) {
            // First update the grid layout
            this.updateGridLayout(true);
            // Then after a tiny delay, add the expanded class to the card
            setTimeout(()=>{
                card.isActive = isActive;
                card.classList.add("is-expanded");
                // Update expanded content width if needed
                if (card.expandedWidth) {
                    const expandedContent = card.querySelector(".expanding-cards__card-expanded-content");
                    const expandedTitle = card.querySelector(".expanding-cards__card-title-expanded");
                    const description = card.querySelector(".expanding-cards__card-description");
                    const contentWidth = card.expandedWidth - 80; // Account for padding
                    if (expandedTitle) expandedTitle.style.width = `${contentWidth}px`;
                    if (description) description.style.width = `${contentWidth}px`;
                }
            }, 10);
        } else {
            card.isActive = isActive;
            card.classList.remove("is-expanded");
            this.updateGridLayout(false);
        }
    }
    resetCards(ignore) {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.cards.forEach((card)=>{
            if (card !== ignore) {
                card.isHovered = false;
                card.isActive = false;
                card.classList.remove("is-expanded");
            }
        });
        if (!ignore) this.updateGridLayout(false);
        // Reset animation lock after animation completes
        if (this.animationTimeout) window.clearTimeout(this.animationTimeout);
        this.animationTimeout = window.setTimeout(()=>{
            this.isAnimating = false;
            this.animationTimeout = null;
        }, 500); // Match the transition duration in CSS
    }
    updateGridLayout(hasExpandedCard) {
        if (this.grid) {
            if (hasExpandedCard) this.grid.classList.add("has-expanded-card");
            else this.grid.classList.remove("has-expanded-card");
        }
    }
    handleResize(isMobile) {
        // Reset all cards on resize to prevent layout issues
        this.resetCards();
        if (isMobile) // Make cards a carousel
        this.initCarousel();
        else this.destroyCarousel();
    }
    initCarousel() {
        // Make cards a carousel
        if (!this.grid) return;
        if (this.carousel) {
            this.calculateExpandedWidths();
            setTimeout(()=>{
                this.carousel?.resize();
            }, 10);
        } else this.carousel = (0, _carouselManager.carouselManager).initCarousel(this.grid, this.id, {
            defaultConfig: {
                cellAlign: "left"
            }
        });
    }
    destroyCarousel() {
        if (this.carousel) {
            this.carousel.destroy();
            this.carousel = undefined;
        }
    }
    get isMobile() {
        return window.matchMedia(`(max-width: ${mobileBreakpoint}px)`).matches;
    }
    // Clean up when the section is unloaded
    destroy() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.animationTimeout) window.clearTimeout(this.animationTimeout);
        if (this.hoverIntentTimeout) window.clearTimeout(this.hoverIntentTimeout);
        // The expansionCalculator doesn't have anything to clean up,
        // but we can set it to null for garbage collection
        this.expansionCalculator = null;
    }
}
class ExpandingCardsHoverManager extends (0, _moduleClass.FLModule) {
    constructor(){
        super("ExpandingCardsHoverManager");
        this.instances = [];
        this.instances = Array.from(document.querySelectorAll(".shopify-section--expanding-cards-hover")).map((container)=>{
            return new ExpandingCardsHover(container);
        });
    }
    init() {
        this.instances.forEach((instance)=>{
            instance.init();
        });
    }
}
const expandingCardsHover = new ExpandingCardsHoverManager();

},{"scripts/utils/CarouselManager":"izVcm","../globals/module-class":"2nrKQ","../utils/card-expansion-calculator":"g3inc","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"XJY2c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAnimatedCards", ()=>ScrollAnimatedCards);
parcelHelpers.export(exports, "scrollAnimatedCards", ()=>scrollAnimatedCards);
var _moduleClass = require("../globals/module-class");
const Motion = window.Motion;
/**
 * We want over the card to take up 50% of the screen before the animation triggers,
 * that way we don't get into a scroll state where scrolling down just enough
 * to trigger the next card isn't quite enough to trigger the previous animation
 * when scrolling back up immediately.
 **/ const percentOnScreenToTrigger = 50;
/** The height of the card in vh, matches CSS */ const cardHeightVh = 80;
/** Breakpoint for disabling animations on mobile */ const MOBILE_BREAKPOINT = 1023;
class ScrollAnimatedCards extends (0, _moduleClass.FLModule) {
    constructor(){
        super("ScrollAnimatedCards");
        this.section = null;
        this.cards = null;
        this.spacers = null;
        this.scrollDirection = "up";
        this.lastScrollY = 0;
        this.isMobile = false;
        this.listenerUnsubscribers = [];
    }
    init() {
        this.section = document.querySelector(".shopify-section--scroll-animated-cards");
        if (!this.section) return;
        this.spacers = this.section.querySelectorAll(".scroll-animated-cards__spacer");
        this.cards = this.section.querySelectorAll(".scroll-animated-cards__card");
        if (!this.cards?.length) return;
        this.isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
        // Add resize listener to update mobile state
        window.addEventListener("resize", ()=>{
            const wasMobile = this.isMobile;
            this.isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
            // If transitioning between mobile and desktop, reset and apply appropriate setup
            if (wasMobile !== this.isMobile) {
                if (this.isMobile) {
                    this.log("Setting up mobile layout");
                    this.cleanup();
                    this.setupMobileLayout();
                } else {
                    this.log("Setting up scroll animations");
                    this.setupScrollAnimations();
                    this.setupInitialCardStates();
                }
            }
        });
        if (this.isMobile) this.setupMobileLayout();
        else {
            this.setupScrollAnimations();
            if (document.readyState === "complete") requestAnimationFrame(()=>{
                this.setupInitialCardStates();
            });
            else document.addEventListener("DOMContentLoaded", ()=>{
                requestAnimationFrame(()=>{
                    this.setupInitialCardStates();
                });
            });
        }
    }
    cleanup() {
        this.listenerUnsubscribers.forEach((unsubscribe)=>unsubscribe());
    }
    /**
   * Sets up a static layout for mobile devices without animations
   */ setupMobileLayout() {
        if (!this.cards) return;
        // Make all cards visible without animation
        this.cards.forEach((card)=>{
            const { content, image, overlay } = this.getCardEls(card);
            // Reset styles
            content.removeAttribute("style");
            image.removeAttribute("style");
            overlay.removeAttribute("style");
            card.removeAttribute("style");
            card.getAnimations().forEach((animation)=>{
                animation.cancel();
            });
        });
    }
    /**
   * PLAN
   * Content is positioned absolutely at the top of the container.
   * - Image and text are opacity: 0 and y: 75 to start with
   * - When card is 200px in view,
   *   - Animate opacity: 1 and y: 0 for content
   *   - Animate y: 0 for image
   *   - Animate overlay to reveal the image
   */ setupScrollAnimations() {
        if (!this.cards || !Motion || !this.spacers || this.isMobile) return;
        const scrollListener = (e)=>{
            this.scrollDirection = window.scrollY > this.lastScrollY ? "down" : "up";
            this.log("Setting scroll direction to", this.scrollDirection, {
                lastScrollY: this.lastScrollY,
                scrollY: window.scrollY
            });
            this.lastScrollY = window.scrollY;
        };
        window.addEventListener("scroll", scrollListener);
        this.listenerUnsubscribers.push(()=>window.removeEventListener("scroll", scrollListener));
        this.spacers.forEach((spacer, index)=>{
            // Create the scroll-linked animation
            this.log("Setting up spacer", spacer);
            const cancelInView = Motion.inView(spacer, ()=>{
                this.log("In view, scrolling in direction:", this.scrollDirection);
                const card = this.cards?.[index];
                // First, animate out the previous card
                this.log({
                    index,
                    card
                });
                const isFirstCard = index === 0;
                const isLastCard = index === (this.cards?.length ?? 0) - 1;
                if (card) {
                    const outCard = this.getOutCard(index);
                    if (outCard) {
                        if (this.scrollDirection === "up") this.animateCardOut(outCard);
                        else if (this.scrollDirection === "down") this.animateCardOut(outCard);
                    }
                    if (this.scrollDirection === "up" && !isLastCard) this.animateCardIn(card);
                    else if (this.scrollDirection === "down" && !isFirstCard) this.animateCardIn(card);
                    // Add a nice parallax effect triggered by spacer position so users don't feel like they're stuck
                    const cancelScroll = Motion.scroll(Motion.animate(card, {
                        transform: [
                            `translateY(20%)`,
                            "translateY(-10%)"
                        ]
                    }, {
                        easing: "linear"
                    }), {
                        target: spacer,
                        offset: [
                            "start end",
                            "end start"
                        ]
                    });
                    this.listenerUnsubscribers.push(cancelScroll);
                }
                // Must return exit animation to have the entry animation trigger every time
                return ()=>{};
            }, {
                amount: percentOnScreenToTrigger / cardHeightVh
            });
        });
    }
    animateCardIn(card, { contentDistance = 200, duration = 0.6 } = {}) {
        if (this.isMobile) {
            this.log("Skipping card in animation on mobile");
            return;
        }
        this.log("Animating card in", card);
        const { content, image, overlay } = this.getCardEls(card);
        const direction = this.scrollDirection === "up" ? -1 : 1;
        Motion.animate(content, {
            opacity: [
                0,
                0,
                1
            ],
            y: [
                contentDistance * direction,
                contentDistance * direction,
                0
            ]
        }, {
            duration,
            offset: [
                0,
                0.4,
                1
            ],
            easing: "ease-out"
        });
        // Animate current card's image
        Motion.animate(image, {
            y: [
                100 * direction,
                80 * direction,
                45 * direction,
                0
            ],
            opacity: [
                0,
                1,
                1,
                1
            ],
            height: [
                "0%",
                "0%",
                "100%",
                "100%"
            ]
        }, {
            duration,
            offset: [
                0,
                0.2,
                0.65,
                1
            ],
            easing: "ease-in"
        });
        // Animate reveal overlay (slides down to reveal image from bottom up)
        if (direction === -1) {
            this.log("Adding bottom overlay", overlay);
            overlay.classList.add("image-reveal-overlay--bottom");
        } else {
            this.log("Removing bottom overlay", overlay);
            overlay.classList.remove("image-reveal-overlay--bottom");
        }
        Motion.animate(overlay, {
            height: [
                "100%",
                "100%",
                "0%"
            ]
        }, {
            duration,
            offset: [
                0,
                0.65,
                1
            ],
            easing: "ease-in-out"
        });
    }
    animateCardOut(card, { contentDistance = 200, duration = 0.6 } = {}) {
        if (this.isMobile) {
            this.log("Skipping card out animation on mobile");
            return;
        }
        this.log("Animating card out", card);
        const { content, image, overlay } = this.getCardEls(card);
        const direction = this.scrollDirection === "down" ? -1 : 1;
        Motion.animate(content, {
            opacity: [
                1,
                0,
                0
            ],
            y: [
                0,
                contentDistance * direction,
                contentDistance * direction
            ]
        }, {
            duration,
            offset: [
                0,
                0.4,
                1
            ],
            easing: "ease-in"
        });
        // Animate previous card's image up
        Motion.animate(image, {
            y: [
                0,
                `${direction * 80}%`,
                `${direction * 100}%`
            ],
            opacity: [
                1,
                1,
                0
            ]
        }, {
            duration,
            offset: [
                0,
                0.8,
                1
            ],
            easing: "ease-out"
        });
    }
    getCardEls(card) {
        return {
            content: card.querySelector(".scroll-animated-cards__content-wrap"),
            image: card.querySelector(".scroll-animated-cards__image-container"),
            overlay: card.querySelector(".image-reveal-overlay")
        };
    }
    getOutCard(currentIndex) {
        if (this.scrollDirection === "up") return this.cards?.[currentIndex + 1] ?? null;
        return this.cards?.[currentIndex - 1] ?? null;
    }
    /**
   * Sets up the initial states of cards based on the current scroll position.
   * - If above section: first card visible
   * - If within section: appropriate card visible based on scroll position
   * - If below section: last card visible
   */ setupInitialCardStates() {
        if (!this.section || !this.cards || !this.cards.length || !this.spacers || this.isMobile) return;
        // Get section position relative to viewport
        const sectionRect = this.section.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const scrollY = window.scrollY;
        // Initialize all cards to their "out" state
        this.cards.forEach((card)=>{
            const { content, image, overlay } = this.getCardEls(card);
            // Set initial hidden state for all cards
            content.style.opacity = "0";
            content.style.transform = "translateY(200px)";
            image.style.opacity = "0";
            image.style.transform = "translateY(100%)";
            image.style.height = "0%";
            overlay.style.height = "100%";
        });
        // Determine which card should be visible
        let activeCardIndex;
        if (sectionRect.top > scrollY + viewportHeight) {
            // Section is below viewport - no cards visible yet
            // The first card will become visible when scrolling down
            this.log("Section is below viewport - no cards visible yet", sectionRect.top, scrollY + viewportHeight);
            activeCardIndex = 0;
        } else if (sectionRect.bottom < 0) {
            // Section is completely above viewport - show last card
            this.log("Section is completely above viewport - show last card");
            activeCardIndex = this.cards.length - 1;
        } else {
            // Section is partially in viewport - find visible spacer/card
            this.log("Section is partially in viewport - find visible spacer/card");
            activeCardIndex = -1;
            // Find the spacer that's currently most visible in the viewport
            const visibilityThreshold = percentOnScreenToTrigger / cardHeightVh;
            for(let i = 0; i < this.spacers.length; i++){
                const spacer = this.spacers[i];
                const spacerRect = spacer.getBoundingClientRect();
                // Calculate visibility percentage (0 to 1)
                const spacerVisibleHeight = Math.min(spacerRect.bottom, viewportHeight + scrollY) - Math.max(spacerRect.top, 0);
                const spacerVisiblePercent = spacerVisibleHeight / spacerRect.height;
                // If this spacer is sufficiently visible, its corresponding card should be active
                if (spacerVisiblePercent >= visibilityThreshold) {
                    activeCardIndex = i;
                    // Determine scroll direction for animation purposes
                    this.scrollDirection = spacerRect.top < viewportHeight / 2 ? "down" : "up";
                    break;
                }
            }
            // If no spacer was sufficiently visible but we're in the section,
            // activate the first card if we're near the top or the last card if we're near the bottom
            if (activeCardIndex === -1) {
                if (sectionRect.top < viewportHeight / 2) {
                    activeCardIndex = 0;
                    this.scrollDirection = "down";
                } else {
                    activeCardIndex = this.cards.length - 1;
                    this.scrollDirection = "up";
                }
            }
        }
        this.log("Active card index", activeCardIndex);
        // If we found an active card, animate it in immediately
        if (activeCardIndex >= 0 && activeCardIndex < this.cards.length) {
            const activeCard = this.cards[activeCardIndex];
            // Use a short duration for the initial animation
            this.animateCardIn(activeCard, {
                duration: 0
            });
        }
    }
}
const scrollAnimatedCards = new ScrollAnimatedCards();

},{"../globals/module-class":"2nrKQ","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"3uhO8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyCards", ()=>StickyCards);
parcelHelpers.export(exports, "stickyCards", ()=>stickyCards);
var _carouselManager = require("scripts/utils/CarouselManager");
var _moduleClass = require("../globals/module-class");
class StickyCards extends (0, _moduleClass.FLModule) {
    constructor(){
        super("StickyCards");
    }
    init() {
        const stickyCarousels = document.querySelectorAll(".sticky-cards__cards");
        for (const carousel of stickyCarousels){
            const sectionId = carousel.closest(".shopify-section")?.id;
            if (!sectionId) continue;
            (0, _carouselManager.carouselManager).initCarousel(carousel, sectionId, {
                defaultConfig: {},
                breakpoints: {
                    1023: {
                        cellAlign: "center"
                    }
                }
            });
        }
    }
}
const stickyCards = new StickyCards();

},{"scripts/utils/CarouselManager":"izVcm","../globals/module-class":"2nrKQ","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"gyUlW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageHero", ()=>ImageHero);
parcelHelpers.export(exports, "imageHero", ()=>imageHero);
var _moduleClass = require("../globals/module-class");
var _carouselManager = require("../utils/CarouselManager");
class ImageHero extends (0, _moduleClass.FLModule) {
    constructor(){
        super("ImageHero");
        this.carouselManager = new (0, _carouselManager.CarouselManager)();
    }
    init() {
        document.addEventListener("DOMContentLoaded", ()=>{
            const heroSections = document.querySelectorAll(".shopify-section--image-hero");
            if (!heroSections.length) return;
            heroSections.forEach((section)=>{
                this.log("Initializing hero section", section);
                this.initHeroSection(section);
            });
        });
    }
    initHeroSection(section) {
        const carouselWrapper = section.querySelector(".image-hero__carousel-wrapper");
        this.log("Carousel wrapper", carouselWrapper);
        if (!carouselWrapper) return;
        const carousel = carouselWrapper.querySelector(".image-hero__carousel");
        const sectionId = section.id;
        this.log("Carousel", carousel);
        this.log("Section ID", sectionId);
        if (!carousel || !sectionId) return;
        // Define carousel configuration
        const carouselConfig = {
            cellAlign: "center",
            wrapAround: true,
            autoPlay: 2000,
            prevNextButtons: false,
            pageDots: false,
            adaptiveHeight: false,
            draggable: true
        };
        // Initialize the carousel
        this.carouselManager.initCarousel(carousel, sectionId, {
            defaultConfig: carouselConfig,
            defaultBehavior: "on"
        });
    }
}
const imageHero = new ImageHero();

},{"../globals/module-class":"2nrKQ","../utils/CarouselManager":"izVcm","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"dsJyx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InfoCardGrid", ()=>InfoCardGrid);
parcelHelpers.export(exports, "infoCardGrid", ()=>infoCardGrid);
var _moduleClass = require("../globals/module-class");
var _carouselManager = require("../utils/CarouselManager");
class InfoCardGrid extends (0, _moduleClass.FLModule) {
    constructor(){
        super("InfoCardGrid");
        this.carousels = [];
        this.isMobileCarouselEnabled = false;
        this.carousels = Array.from(document.querySelectorAll(".info-card-grid__content")).map((container)=>({
                id: container.closest(".shopify-section")?.id ?? "",
                cards: container.querySelectorAll(".info-card-grid__card--content"),
                container: container
            }));
    }
    init() {
        this.handleResponsiveCarousel();
        window.addEventListener("resize", ()=>this.handleResponsiveCarousel());
        this.initializeDesktopCards();
    }
    initializeDesktopCards() {
        this.carousels.forEach(({ cards })=>{
            cards.forEach((card)=>{
                card.addEventListener("click", ()=>{
                    // Only handle clicks on desktop
                    if (window.innerWidth >= 1024) {
                        // Toggle the open state of the clicked card
                        card.classList.toggle("is-open");
                        // Close other cards when one is opened
                        cards.forEach((otherCard)=>{
                            if (otherCard !== card && otherCard.classList.contains("is-open")) otherCard.classList.remove("is-open");
                        });
                    }
                });
            });
        });
    }
    handleResponsiveCarousel() {
        const isMobile = window.innerWidth < 1024;
        if (isMobile && !this.isMobileCarouselEnabled) this.enableMobileCarousel();
        else if (!isMobile && this.isMobileCarouselEnabled) this.disableMobileCarousel();
    }
    enableMobileCarousel() {
        if (!this.carousels.length) return;
        // Add carousel classes
        this.carousels.forEach(({ container, cards, id })=>{
            if (!container) return;
            container?.classList.add("info-card-grid__content--carousel");
            (0, _carouselManager.carouselManager).initCarousel(container, id, {
                defaultConfig: {
                    cellAlign: "center",
                    cellSelector: ".info-card-grid__card:not(.hide-mobile)",
                    prevNextButtons: false,
                    pageDots: false,
                    contain: true,
                    adaptiveHeight: true,
                    dragThreshold: 10,
                    selectedAttraction: 0.2,
                    friction: 0.8
                }
            });
            cards.forEach((card)=>{
                card.classList.add("is-expanded");
                card.classList.remove("is-open");
            });
        });
        this.isMobileCarouselEnabled = true;
    }
    disableMobileCarousel() {
        if (!this.carousels.length) return;
        // Remove carousel
        // Remove carousel classes
        this.carousels.forEach(({ container, cards, id })=>{
            if (!container) return;
            (0, _carouselManager.carouselManager).destroyCarousel(id);
            container.classList.remove("info-card-grid__content--carousel");
            cards.forEach((card)=>{
                card.classList.remove("is-expanded");
            });
        });
        this.isMobileCarouselEnabled = false;
    }
}
const infoCardGrid = new InfoCardGrid();

},{"../globals/module-class":"2nrKQ","../utils/CarouselManager":"izVcm","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"kqvQC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Register the custom element
parcelHelpers.export(exports, "ProductPaymentTabs", ()=>ProductPaymentTabs);
parcelHelpers.export(exports, "productPaymentTabs", ()=>productPaymentTabs);
var _logger = require("scripts/globals/logger");
var _moduleClass = require("../globals/module-class");
class PaymentTabs extends HTMLElement {
    constructor(){
        super();
        const logger = (0, _logger.createLogger)("ProductPaymentTabs");
        this.log = logger.log;
        this.trace = logger.trace;
        this.log("constructor");
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.productForm = this.closest("product-info");
        // Build price selectors from tab data attributes
        this.priceSelectors = this.tabs.map((tab)=>tab.dataset.priceTarget).filter((selector)=>!!selector);
        this.log("Price selectors:", this.priceSelectors);
        // Bind event handlers
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        // Add event listeners
        this.tabs.forEach((tab)=>{
            tab.addEventListener("click", this.handleClick);
            tab.addEventListener("keydown", this.handleKeydown);
        });
        this.activateTab(this.tabs[0]);
    }
    handleClick(event) {
        const tab = event.currentTarget;
        this.activateTab(tab);
    }
    handleKeydown(event) {
        const target = event.target;
        const currentIndex = this.tabs.indexOf(target);
        switch(event.key){
            case "ArrowLeft":
            case "ArrowUp":
                event.preventDefault();
                this.focusTab(currentIndex - 1);
                break;
            case "ArrowRight":
            case "ArrowDown":
                event.preventDefault();
                this.focusTab(currentIndex + 1);
                break;
            case "Home":
                event.preventDefault();
                this.focusTab(0);
                break;
            case "End":
                event.preventDefault();
                this.focusTab(this.tabs.length - 1);
                break;
        }
    }
    focusTab(index) {
        // Handle wrapping
        if (index < 0) index = this.tabs.length - 1;
        if (index >= this.tabs.length) index = 0;
        const tab = this.tabs[index];
        tab.focus();
        this.activateTab(tab);
    }
    activateTab(tab) {
        // Update tab states
        this.tabs.forEach((t)=>{
            const isActive = t === tab;
            t.classList.toggle("is-active", isActive);
            t.setAttribute("aria-selected", isActive.toString());
            t.tabIndex = isActive ? 0 : -1;
        });
        // Update price visibility
        if (this.productForm) {
            const priceTarget = tab.dataset.priceTarget;
            if (priceTarget) {
                // Hide all price elements using the dynamically built selectors
                const allPriceElements = this.productForm.querySelectorAll(this.priceSelectors.join(", "));
                this.log("Hiding price elements:", allPriceElements);
                allPriceElements.forEach((element)=>{
                    element.classList.add("!hidden");
                });
                // Show the target price element
                const targetPriceElements = this.productForm.querySelectorAll(priceTarget);
                this.log("Showing price element:", targetPriceElements);
                if (targetPriceElements.length) {
                    this.log("Showing price element:", targetPriceElements);
                    targetPriceElements.forEach((element)=>{
                        element.classList.remove("!hidden");
                    });
                }
            }
        }
    }
}
class ProductPaymentTabs extends (0, _moduleClass.FLModule) {
    constructor(){
        super("ProductPaymentTabs");
    }
    init() {
        this.log("init");
        customElements.define("payment-tabs", PaymentTabs);
    }
}
const productPaymentTabs = new ProductPaymentTabs();

},{"scripts/globals/logger":"k7M8y","../globals/module-class":"2nrKQ","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}],"eSyom":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Gorgias", ()=>Gorgias);
parcelHelpers.export(exports, "gorgias", ()=>gorgias);
var _moduleClass = require("../globals/module-class");
class Gorgias extends (0, _moduleClass.FLModule) {
    constructor(){
        super("Gorgias");
    }
    init() {
        var initGorgiasChatPromise = window.GorgiasChat ? window.GorgiasChat.init() : new Promise(function(resolve) {
            window.addEventListener("gorgias-widget-loaded", function() {
                resolve(void 0);
            });
        });
        initGorgiasChatPromise.then(function() {
            var timer = setInterval(function() {
                var chatButtonHead = document.querySelector("#gorgias-chat-container")?.querySelector("#chat-button")?.contentWindow?.document.querySelector("head");
                if (!chatButtonHead || ![
                    ...chatButtonHead.children
                ].some((x)=>x.getAttribute("data-emotion"))) return;
                clearInterval(timer);
                var buttonStyle = document.createElement("style");
                buttonStyle.textContent = `
        #gorgias-chat-messenger-button {
          background-color: #41AFC9 !important;
          transition: background-color 200ms ease;
        }
        #gorgias-chat-messenger-button svg path {
          fill: #FFFFFF !important;
        }
      `;
                chatButtonHead.appendChild(buttonStyle);
            }, 50);
        });
    }
}
const gorgias = new Gorgias();

},{"../globals/module-class":"2nrKQ","@parcel/transformer-js/src/esmodule-helpers.js":"5fhYl"}]},["3KXs3"], "3KXs3", "parcelRequiree406")

